const en = {
	translations: {
		// Business activity after activation, release for revision (request #230)
		'Business change hygiene dropped': "The food hygiene/allergen training confirmation no longer applies (the previous one stays in the history).",
		'Business change hygiene required': "The food hygiene/allergen training confirmation will be required — students see the notice in their company profile.",
		'Business change hygiene kept': "The existing food hygiene/allergen training confirmation remains valid.",
		'Business change certificate renewed': "The company register extract will be regenerated.",
		'Business change lists follow': "Lists, statistics and expert matching show the new branch from now on.",
		'Business change activation stays': "The activation remains; students and teachers see the change under \"Messages from the administration\".",
		'No changes to save': "There is nothing to save.",
		'Change business activity?': "Change business activity?",
		'Business change what changes': "What changes:",
		'Business change consequences': "Consequences:",
		'Business change certificate failed': "Saved — but the company register extract could not be regenerated. Please check under \"Documents\" or save again later.",
		'Business change saved, certificate renewed': "Saved, the company register extract has been regenerated.",
		'Release for revision': "Release for revision",
		'Release for revision explanation': "Students can edit the business activity (including the branch) and the market and risk analysis again. The activation remains, nothing is reviewed again.",
		'Released until (inclusive)': "Released until (inclusive)",
		'Until revoked': "Until revoked (no end date)",
		'Release': "Release",
		'Please choose an end date': "Please pick an end date or tick \"Until revoked\".",
		'Released for revision': "Released for revision",
		'Revoke release?': "Revoke release?",
		'Revoke release explanation': "Students will no longer be able to edit the branch and the market and risk analysis. Anything already saved stays.",
		'Revoke release': "Revoke release",
		'Release revoked': "Release revoked",
		'Released for revision until further notice': "Released for revision by the students — until revoked.",
		'Released for revision until {{date}}': "Released for revision by the students until {{date}} (inclusive).",
		'Release expired on {{date}}': "Locked — the last release expired on {{date}}.",
		'Locked for students since the activation': "Locked — since the activation, students can no longer change the branch or the market and risk analysis.",
		'Editing by the students': "Editing by the students",
		'Editing by the students note': "Applies to the business activity (including the branch) and the market and risk analysis.",
		'Change release period': "Change release",
		'Release editing for students': "Release editing for students",
		'Released for revision by the administration until further notice': "Released for revision by the administration — until further notice.",
		'Released for revision by the administration until {{date}}': "Released for revision by the administration until {{date}}.",
		'Business activity changed': "Business activity changed",
		'Market and risk analysis changed during the release': "Market and risk analysis changed during the release",
		// Delete a teacher account (request #239)
		'Teacher account deleted': 'Teacher account deleted',
		teacherRemovalNoSchool: 'not assigned to a school',
		teacherRemovalCompanies: 'Assigned Junior Companies:',
		teacherRemovalNoCompanies: 'none',
		teacherRemovalItemSupervision: 'assignments to Junior Companies',
		teacherRemovalItemRequests: 'open supervision requests',
		teacherRemovalKept:
			'Whatever belongs to the Junior Company, the school or the administration stays — without reference to the person ({{count}} entries: e.g. concept assessments, requests, history entries).',
		teacherRemovalOnlyTeacher:
			'{{name}} is the only teacher of the Junior Company "{{company}}". Please first enter another supervising teacher in the Junior Company profile or merge the teacher with another account.',
		teacherRemovalSupervisionPasses:
			'{{name}} is the supervising teacher of "{{company}}". {{successor}} will take over the supervision.',
		teacherRemovalNotATeacher: 'Only teacher accounts can be deleted here.',
		// Delete a student account (request #226)
		'Student account deleted': 'Student account deleted',
		'Delete account': 'Delete account',
		studentRemovalTitle: 'Delete account permanently?',
		studentRemovalNoCompany: 'not assigned to a Junior Company',
		studentRemovalDeletedHeading: 'This will be deleted:',
		studentRemovalItemAccount: 'the account including sign-in, personal data and profile picture',
		studentRemovalItemDocuments: 'personal proofs (parental consent, course certificate, certificate, participation confirmation) including files',
		studentRemovalItemNotifications: 'notifications to the person',
		studentRemovalItemCourse: 'learning path and quiz progress',
		studentRemovalItemConcept: 'assignments and exemptions in the Skills4Retail concept',
		studentRemovalItemInvitations: 'invitations to their e-mail address',
		studentRemovalItemComments: 'comments of the administration about this person',
		studentRemovalItemSettings: 'other personal settings',
		studentRemovalKept:
			'Whatever belongs to the Junior Company or the administration stays — without reference to the person ({{count}} entries: e.g. reports, invoices, shareholders, requests, history entries).',
		studentRemovalFinal: 'Deleting is permanent and cannot be undone.',
		studentRemovalTypeLastName: 'To confirm, please enter the last name "{{lastName}}":',
		studentRemovalConfirm: 'Delete permanently',
		studentRemovalDone: 'The account of {{name}} has been deleted.',
		studentRemovalBlockedTitle: 'Account cannot be deleted',
		studentRemovalLastStudent:
			'{{name}} is the only student of the Junior Company "{{company}}". Please delete the Junior Company instead.',
		studentRemovalCeo:
			'{{name}} is the managing director (CEO) of "{{company}}". Afterwards the Junior Company has no managing director until the students assign one under "Employees".',
		studentRemovalBelowTwo:
			'"{{company}}" is activated and will then have only {{count}} student — the requirement "at least two employees" is no longer met.',
		studentRemovalNotAStudent: 'Only student accounts can be deleted here.',
		// Nur-Lese-Zugang Alumni (Anforderung #213)
		'Read-only access': 'Read-only access',
		'readOnlyAccessHint': 'You see the database nationwide, but read-only: without contact details of students and teachers, without documents and exports.',
		'ALUMNI': 'Alumni',
		'alumniRoleHint': 'Alumni (JA Alumni Austria) see nationwide what is new in the database — read-only, with names but without contact details of students and teachers, without documents and exports. No access to requirements, settings, administration and communication.',
		'alumniResponsibilityHint': 'Austria-wide, read-only — no federal state.',
		'invitedByRoleALUMNI': 'Alumni',
		'Invited person': 'Invited person',
		// ALUMNI-ENDE
		// Erinnerungen per E-Mail der Verwaltung (Profil + Administration, 14.10.2026)
		'Reminders': 'Reminders',
		'Email reminders': 'Email reminders',
		'Assigned requirements': 'Assigned requirements',
		'Open reviews': 'Open reviews',
		'reminderAssignedHint': 'Overview of the requirements assigned to you that are neither completed nor discarded: the number and the five most urgent ones. If nothing is open, no email is sent. Whoever switches this on no longer receives the weekly overview from the settings in addition.',
		'reminderReviewsHintState': 'What is waiting for the administration in your own federal state: companies submitted for approval, unchecked parental confirmations and course certificates, unanswered requests. Each line of the email leads to the filtered list. If everything is zero, no email is sent.',
		'reminderReviewsHintFederal': 'What is waiting for the administration across Austria: companies submitted for approval, unchecked parental confirmations and course certificates, supporters awaiting approval, unanswered requests. Each line of the email leads to the filtered list. If everything is zero, no email is sent.',
		'Rhythm': 'Rhythm',
		'reminderFrequencyOFF': 'Off',
		'reminderFrequencyDAILY': 'Daily',
		'reminderFrequencyWEEKLY': 'Weekly',
		'Weekday': 'Weekday',
		'reminderWeekday1': 'Monday',
		'reminderWeekday2': 'Tuesday',
		'reminderWeekday3': 'Wednesday',
		'reminderWeekday4': 'Thursday',
		'reminderWeekday5': 'Friday',
		'reminderWeekday6': 'Saturday',
		'reminderWeekday7': 'Sunday',
		'reminderWeekdayShort1': 'Mon',
		'reminderWeekdayShort2': 'Tue',
		'reminderWeekdayShort3': 'Wed',
		'reminderWeekdayShort4': 'Thu',
		'reminderWeekdayShort5': 'Fri',
		'reminderWeekdayShort6': 'Sat',
		'reminderWeekdayShort7': 'Sun',
		'reminderDailyShort': 'daily',
		'reminderShortASSIGNED_TICKETS': 'Requirements',
		'reminderShortOPEN_REVIEWS': 'Reviews',
		'Time (Vienna)': 'Time (Vienna)',
		'Additionally right away when newly assigned': 'Additionally right away when newly assigned',
		'Next check': 'Next run',
		'Last sent': 'Last sent',
		'No reminder sent yet': 'No reminder sent yet',
		'Not saved yet': 'Not saved yet',
		'Save reminders': 'Save reminders',
		'Reminders saved': 'Reminders saved',
		'Reminders could not be saved.': 'The reminders could not be saved.',
		'Reminders could not be loaded.': 'The reminders could not be loaded.',
		'Loading reminders': 'Loading reminders …',
		'remindersOwnHint': 'Applies only to your own account. The federal administration can set the reminders of all administration accounts under “Administration”; every change is recorded in the account\'s history.',
		'remindersOtherHint': 'You are setting the reminders of this account. The person sees them under “My Profile”; the change is recorded in the “Comments” tab.',
		'No reminders': 'No reminders',
		'Reminder changes': 'Reminders changed',
		'Course certificate status': 'Course certificate',
		// Einstellungen → Anfragen: Zuständig für Skills4Retail-Anfragen (#216)
		'Responsible for Skills4Retail requests':
			'Responsible for Skills4Retail requests',
		'Account #{{val1}} (no longer a federal admin)':
			'Account #{{val1}} (no longer a federal admin)',
		'Example: Viktoria Vidackovic is selected — a student asks about the third quiz in chapter 3 via the help button and chooses „Skills4Retail“. The request is assigned to Viktoria Vidackovic and booked to the project „Skills4Retail“; the state support of the student does not receive it.':
			'Example: Viktoria Vidackovic is selected — a student asks about the third quiz in chapter 3 via the help button and chooses „Skills4Retail“. The request is assigned to Viktoria Vidackovic and booked to the project „Skills4Retail“; the state support of the student does not receive it.',
		'Without a selection, Skills4Retail requests go to the responsible state support like every other request — the project is still set.':
			'Without a selection, Skills4Retail requests go to the responsible state support like every other request — the project is still set.',
		'In the help form, students and teachers can choose „Skills4Retail“ as a fourth topic. Such requests are assigned automatically to the person selected here, so that one person handles all of them across the federal states. The assignment appears in the history of the request, and the person receives the usual message about a new request. Supporters do not see this topic.':
			'In the help form, students and teachers can choose „Skills4Retail“ as a fourth topic. Such requests are assigned automatically to the person selected here, so that one person handles all of them across the federal states. The assignment appears in the history of the request, and the person receives the usual message about a new request. Supporters do not see this topic.',
		'Responsible person':
			'Responsible person',
		'Nobody — usual way via the federal state':
			'Nobody — usual way via the federal state',
		'Project':
			'Project',
		'No project':
			'No project',
		'This requirement was added after your company was activated and is therefore not required of you.':
			'This requirement was added after your company was activated and is therefore not required of you.',
		'Free · no account needed': 'Free · no account needed',
		'Skills4Retail — your online shop course': 'Skills4Retail – Marketing & E-Commerce',
		'The turbo for your Junior Company: how an online shop earns money, how customers find you, what you sell and where you get it, payment, shipping, marketing. Test yourself after every chapter.':
			'The turbo for your Junior Company: how an online shop earns money, how customers find you, what you sell and where you get it, payment, shipping, marketing. Test yourself after every chapter.',
		'Start the course': 'Start the course',
		'The new school year starts here': 'The new school year starts here',
		'No Junior Company is listed yet — yours could be the first.':
			'No Junior Company is listed yet — yours could be the first.',
		'Found your Junior Company': 'Found your Junior Company',
		// Der wechselnde Aufmacher der öffentlichen Startseite (components/NewsBanner)
		'Annual report · school year 2025/26': 'Annual report · school year 2025/26',
		'Junior-Bilanz 2025/26': 'Junior-Bilanz 2025/26',
		'592 Junior Companies, 4,966 students at 185 schools in 9 federal states — and 281 companies that made it all the way to the certificate. The public edition shows what a school year of Junior moves.':
			'592 Junior Companies, 4,966 students at 185 schools in 9 federal states — and 281 companies that made it all the way to the certificate. The public edition shows what a school year of Junior moves.',
		'Read the report': 'Read the report',
		'Public edition · without financial results · excl. Junior Mini Companies':
			'Public edition · without financial results · excl. Junior Mini Companies',
		News: 'News',
		'AI-generated': 'AI-generated',
		'10 chapters · 5 questions each · about 15 minutes per chapter':
			'10 chapters · 5 questions each · about 15 minutes per chapter',
		'Thank you — your request has arrived.': 'Thank you — your request has arrived.',
		'It has the number #{{val1}}.': 'It has the number #{{val1}}.',
		'We will look into it as soon as possible. You will find it — and the answer — under „My requests", and you will receive a message as soon as there is news.':
			'We will look into it as soon as possible. You will find it — and the answer — under „My requests", and you will receive a message as soon as there is news.',
		'To my requests': 'To my requests',
		'Fehlerbehebung — etwas funktioniert nicht': 'Bug fix — something is not working',
		'Anpassungsbedarf — etwas sollte anders sein': 'Change request — something should be different',
		'Klärungsbedarf — etwas ist unklar': 'Clarification — something is unclear',
		'Skills4Retail — Fragen zum Konzept und zur Lernstrecke':
			'Skills4Retail — questions about the concept and the learning path',
		'These details are sent along': 'These details are sent along',
		Role: 'Role',
		Browser: 'Browser',
		Window: 'Window',
		'Junior Company or school are added automatically, so that the report can be retraced.':
			'Junior Company or school are added automatically, so that the report can be retraced.',
		'Continue later': 'Continue later',
		Discard: 'Discard',
		'Discard draft?': 'Discard draft?',
		'Text and attachments will be lost.': 'Text and attachments will be lost.',
		'Saved as a draft — the help button brings it back.': 'Saved as a draft — the help button brings it back.',
		'Your saved draft has been restored.': 'Your saved draft has been restored.',
		Student: 'Student',
		Teacher: 'Teacher',
		Supporter: 'Supporter',
		'or drag it here or paste it with Ctrl+V': 'or drag it here or paste it with Ctrl+V',
		'Only PNG, JPEG and PDF are possible.': 'Only PNG, JPEG and PDF are possible.',
		Screenshot: 'Screenshot',
		'Show larger': 'Show larger',
		'My requests': 'My requests',
		'Your requests could not be loaded.': 'Your requests could not be loaded.',
		'You have not submitted any requests yet. Use the help button at the bottom right.':
			'You have not submitted any requests yet. Use the help button at the bottom right.',
		'You have not submitted any requests yet.': 'You have not submitted any requests yet.',
		'This request could not be loaded.': 'This request could not be loaded.',
		'Your message could not be sent.': 'Your message could not be sent.',
		'That did not work.': 'That did not work.',
		'Withdraw request?': 'Withdraw request?',
		'The request will be closed. You can always submit a new one.':
			'The request will be closed. You can always submit a new one.',
		Withdraw: 'Withdraw',
		'Thank you — the request is closed.': 'Thank you — the request is closed.',
		Request: 'Request',
		'Your answer': 'Your answer',
		'Add something': 'Add something',
		Send: 'Send',
		'That solves it': 'That solves it',
		'Not yet solved': 'Not yet solved',
		'Your request has been answered': 'Your request has been answered',
		'Read the answer': 'Read the answer',
		'Question about your request': 'Question about your request',
		'Answer now': 'Answer now',
		'Your request is closed': 'Your request is closed',
		'Your request will not be pursued': 'Your request will not be pursued',
		'Reply to request': 'Reply to request',
		'Request still unanswered': 'Request still unanswered',
		'Request is waiting': 'Request is waiting',
		'Your request has been received': 'Your request has been received',
		'We will get back to you here.': 'We will get back to you here.',
		'New request': 'New request',
		'To the requirements': 'To the requirements',
		Help: 'Help',
		'Help and feedback': 'Help and feedback',
		'Submit a request': 'Submit a request',
		'Hide the help button': 'Hide the help button',
		'Hide — it comes back after {{val1}} page changes': 'Hide — it comes back after {{val1}} page changes',
		'How can we help?': 'How can we help?',
		'What is it about?': 'What is it about?',
		'Something is not working': 'Something is not working',
		'I would like something': 'I would like something',
		'I have a question': 'I have a question',
		'In short': 'In short',
		'What happened?': 'What happened?',
		'What did you do, what happened, and what did you expect?':
			'What did you do, what happened, and what did you expect?',
		'Attach a screenshot or PDF': 'Attach a screenshot or PDF',
		'up to {{val1}} files, {{val2}} MB each': 'up to {{val1}} files, {{val2}} MB each',
		remove: 'remove',
		'We send these details along': 'We send these details along',
		Page: 'Page',
		View: 'View',
		'Plus your role, your Junior Company or school, browser and window size — so that we can retrace what you saw.':
			'Plus your role, your Junior Company or school, browser and window size — so that we can retrace what you saw.',
		'Please do not include passwords. For questions about your company, your teacher is the first port of call.':
			'Please do not include passwords. For questions about your company, your teacher is the first port of call.',
		'Send request': 'Send request',
		'Sending …': 'Sending …',
		'Thank you! Your request has been received under number #{{val1}}.':
			'Thank you! Your request has been received under number #{{val1}}.',
		'The request could not be sent.': 'The request could not be sent.',
		'Please say in one sentence what this is about.': 'Please say in one sentence what this is about.',
		'Please describe briefly what happened (at least {{val1}} characters).':
			'Please describe briefly what happened (at least {{val1}} characters).',
		'„{{val1}}“ is larger than {{val2}} MB.': '„{{val1}}“ is larger than {{val2}} MB.',
		'At most {{val1}} files are possible.': 'At most {{val1}} files are possible.',
		'e.g. „Invoice will not open“': 'e.g. „Invoice will not open“',
		communication: 'Communication',
		Rendered: 'Rendered',
		'HTML source': 'HTML source',
		'Text source': 'Text source',
		'Sample data': 'Sample data',
		'No sample data.': 'No sample data.',
		'This event also triggers an internal message:': 'This event also triggers an internal message:',
		'This event also triggers an email:': 'This event also triggers an email:',
		'Switch to source to edit. The preview uses the sample data on the right.':
			'Switch to source to edit. The preview uses the sample data on the right.',
		Change: 'Change',
		'Some entries are incomplete — the affected steps are marked with a dot.':
			'Some entries are incomplete — the affected steps are marked with a dot.',
		Time: 'Time',
		'Email templates': 'Email templates',
		'Internal messages': 'Internal messages',
		'Document templates': 'Document templates',
		Overview: 'Overview',
		Phases: 'Phases',
		Channel: 'Channel',
		Template: 'Template',
		Email: 'Email',
		Internal: 'Internal',
		Automatic: 'Automatic',
		'sent by the nightly reminder job': 'sent by the nightly reminder job',
		'The axis shows the phases of a Junior Company, not calendar dates. Click a bar for the template details.':
			'The axis shows the phases of a Junior Company, not calendar dates. Click a bar for the template details.',
		'No templates match the current filter.': 'No templates match the current filter.',
		'In the handbook: Documents & certificates': 'In the handbook: Documents & certificates',
		Static: 'Static',
		'Live preview': 'Live preview',
		'The current template is rendered with real (neutralized) production data.':
			'The current template is rendered with real (neutralized) production data.',
		'No matching production data found.': 'No matching production data found.',
		'Production data record': 'Production data record',
		'View PDF': 'View PDF',
		'Download PDF': 'Download PDF',
		'Generating...': 'Generating...',
		'PDF could not be generated': 'PDF could not be generated',
		'Communication templates could not be loaded': 'Communication templates could not be loaded',
		Search: 'Search',
		Subject: 'Subject',
		Inactive: 'Inactive',
		Placeholders: 'Placeholders',
		Edited: 'Edited',
		'Template could not be loaded': 'Template could not be loaded',
		'Back to overview': 'Back to overview',
		'Target group': 'Target group',
		Administration: 'Administration',
		'Triggered by': 'Triggered by',
		'Read more': 'Read more',
		Less: 'Less',
		'Last edited': 'Last edited',
		'Live templates': 'Live templates',
		'These texts are actually sent to users. Edits take effect immediately.':
			'These texts are actually sent to users. Edits take effect immediately.',
		'Active (is being sent)': 'Active (is being sent)',
		'Insert placeholder': 'Insert placeholder',
		'Edit template?': 'Edit template?',
		'Changes to this template go live immediately. From the next trigger onward, the edited version is sent to real recipients.':
			'Changes to this template go live immediately. From the next trigger onward, the edited version is sent to real recipients.',
		'Edit now': 'Edit now',
		'Activate template for real sending?': 'Activate template for real sending?',
		'On saving, this template is switched live and will be sent to real recipients from the next trigger. Continue?':
			'On saving, this template is switched live and will be sent to real recipients from the next trigger. Continue?',
		'Note for the change log (optional)': 'Note for the change log (optional)',
		'e.g. Wording adjusted': 'e.g. Wording adjusted',
		'Save and activate': 'Save and activate',
		'Template saved and activated': 'Template saved and activated',
		'Template could not be saved': 'Template could not be saved',
		'Preview with sample data': 'Preview with sample data',
		Record: 'Record',
		'Refresh preview': 'Refresh preview',
		Preview: 'Preview',
		'Preview could not be rendered': 'Preview could not be rendered',
		'Saving...': 'Saving...',
		'Change log': 'Change log',
		'No changes yet.': 'No changes yet.',
		dashboard: 'Dashboard',
		companyProfile: 'Company Profile',
		riskAnalysis: 'Market and risk analysis',
		employees: 'Employees',
		documents: 'Documents',
		shares: 'Shareholders',
		reports: 'Reports',
		Reports: 'Reports',
		experts: 'Experts',
		companies: 'Companies',
		students: 'Students',
		users: 'Users',
		invoices: 'Invoices',
		income: 'Income',
		emailNewsletter: 'Email & Newsletter',
		newsPages: 'News Pages',
		stateAdmins: 'Administration',
		settings: 'Settings',
		schools: 'Schools',
		profile: 'Profile',
		exit: 'Exit',
		'Economic experts': 'Economic experts',
		'Risk Analysis': 'Market and risk analysis',

		// --- Settings groups ---
		'Master data': 'Master data',
		'Junior Companies': 'Junior Companies',
		Finances: 'Finances',
		'Deadlines & reminders': 'Deadlines & reminders',
		System: 'System',

		// --- Supporter module ---
		supporters: 'Supporters',
		supportRequests: 'Support requests',
		handbook: 'Handbook',
		presentations: 'Presentations',
		presentationsIntro: 'Narrated short presentations of the platform for partners, such as other JA organisations in Europe. Play them, present them or share them as a PDF.',
		presentationOpen: 'Open presentation',
		presentationAll: 'All presentations',
		presentationPlay: 'Play',
		presentationPause: 'Pause',
		presentationRestart: 'Restart',
		presentationPrev: 'Back',
		presentationNext: 'Next',
		presentationVoice: 'Voice',
		presentationMusic: 'Music',
		presentationTempo: 'Speed',
		presentationPdf: 'Download PDF',
		presentationFullscreen: 'Full screen',
		presentationKeys: 'Keys: space play/pause · ←/→ navigate · M music · S voice · F full screen',
		presentationLanguage: 'Language: {{language}}',
		presentationMinutes: 'about {{count}} minutes',
		presentationSlides: '{{count}} slides',
		presentationNotFound: 'This presentation does not exist.',
		tickets: 'Requirements & Requests',
		changelog: 'Development log',
		roles: 'Roles',
		status: 'Status',
		firstName: 'First name',
		lastName: 'Last name',
		email: 'Email address',
		company: 'Company',
		position: 'Position',
		city: 'City',
		edit: 'Edit',
		delete: 'Delete',
		name: 'Name',
		Bio: 'Short profile',
		password: 'Password',
		repeatPassword: 'Repeat password',
		supporter: 'Supporter',
		myProfile: 'My profile',
		myConnections: 'My connections',
		supporterRoleEXPERT: 'Economic expert',
		supporterRoleJURY: 'Jury member',
		supporterRoleTRAINER: 'Trainer',
		possibleRoles: 'Possible roles as a supporter',
		supporterStatusAll: 'All',
		supporterStatusTileHint: 'Click to limit the list to this status',
		supporterStatusINVITED: 'Invited',
		supporterStatusPENDING_APPROVAL: 'Awaiting approval',
		supporterStatusACTIVE: 'Active',
		supporterStatusUNAVAILABLE: 'Unavailable',
		supporterStatusARCHIVED: 'Archived',
		supporterStatusDELETED: 'Deleted',
		profileActive: 'Profile active',
		profileActiveHint: 'While your profile is active, schools can see you.',
		profileInactiveHint: 'Your profile is temporarily deactivated. Your account remains active.',
		unavailableUntil: 'Unavailable until',

		// Temporary pause (UI/UnavailableDialog)
		pauseTitle: 'Set profile to "unavailable"',
		pauseLead: 'You stay signed in and keep all your data. During this time schools cannot find you.',
		pauseLeadAdmin: "{{name}}'s profile stays as it is; during this time schools cannot find it.",
		pauseHowLong: 'For how long?',
		pauseQuickOneWeek: '1 week',
		pauseQuickTwoWeeks: '2 weeks',
		pauseQuickOneMonth: '1 month',
		pauseQuickThreeMonths: '3 months',
		pauseForDuration: 'For a period',
		pauseUnit_days: 'days',
		pauseUnit_weeks: 'weeks',
		pauseUnit_months: 'months',
		pauseUntilDate: 'Up to and including',
		pauseOpenEnded: 'No end date',
		pauseOpenEndedHint: 'The profile stays unavailable until someone sets it back to active.',
		pauseResult: 'Unavailable up to and including {{last}} · automatically active again on {{back}}',
		pauseResultOpen: 'No end date — the profile will not become active on its own.',
		pauseResultMissing: 'Please choose an end date from today onwards.',
		pauseEffectSearch: 'The profile no longer appears in the expert search for schools.',
		pauseEffectRequests: 'New requests from Junior Companies are not possible during this time.',
		pauseEffectRunning:
			'Ongoing collaborations continue: Junior Companies already supported still see the profile and its contact details.',
		pauseEffectAccess: 'Requests that are still open stay open and reminders keep going out.',
		pauseEffectMail: 'You will receive an email — now and again as soon as the profile is active.',
		pauseEffectMailAdmin: 'The person receives an email — now and again as soon as the profile is active.',
		pauseUntilNote: 'Unavailable up to and including {{last}} · active again on {{back}}',
		pauseOpenNote: 'No end date set — the profile will not become active on its own.',
		inviteSupporter: 'Invite supporter',
		resendInvitation: 'Resend invitation',
		withdrawInvitation: 'Withdraw invitation',
		openInvitations: 'Open invitations',
		approveSupporter: 'Approve',
		approveSupporterTitle: 'Approve profile?',
		approveSupporterHint:
			'Please check briefly whether the person can be found online and their details are plausible. Once approved, the profile is visible to schools and the person is notified by email.',
		approveSupporterSearch: 'Search for the person online',
		approveSupporterFederalOnly: 'Approval is granted by the federal administration.',
		deletePendingProfile: 'Delete registration',
		deletePendingProfileHint:
			'The profile will be anonymised and disappear from the list. No notification is sent. This step cannot be undone.',
		competences: 'Competences',
		availableCompetences: 'Available competences',
		furtherCompetences: 'Further competences',
		addOwnCompetence: 'Add your own competence...',
		noOwnCompetences: 'No own competences added.',
		targetGroups: 'Target groups I would like to support',
		schoolTypes: 'School types',
		states: 'Federal states',
		relevantStatesHint:
			'Which federal states are relevant for you? You can adjust this later in your profile at any time.',
		industries: 'Industries',
		selectAll: 'Select all',
		all: 'All',
		// Junior Company participation of supporters (requirement #181)
		juniorAlumniTitle: 'Junior Company participation',
		juniorAlumniQuestion: 'Have you yourself completed one of the programmes offered by Junior Austria?',
		juniorAlumniUnanswered: 'Not specified yet.',
		juniorAlumniSchool: 'School',
		juniorAlumniYear: 'Year of participation',
		juniorAlumniYearRange: 'Please enter a year between {{min}} and {{max}}.',
		juniorAlumniStates: 'Federal states of participation',
		juniorAlumniStatesHint: 'In which federal state(s) did you take part?',
		juniorAlumniStatesRequired: 'Please select at least one federal state.',
		juniorAlumniIncomplete: 'Please complete the details of your Junior Company participation.',
		trainingPortfolio: 'Training portfolio',
		addTraining: 'Add new training',
		trainingTitle: 'Title',
		trainingDuration: 'Duration (hours)',
		trainingFormat: 'Format',
		formatONLINE: 'Online',
		formatPRESENCE: 'On site',
		formatHYBRID: 'Hybrid',
		offers: 'Offers',
		ourExperts: 'Our experts',
		matchingExperts: 'Matching experts',
		allExperts: 'All experts',
		ownExperts: 'Own experts',
		requestExpert: 'Request expert',
		Fit: 'Fit',
		onlyMatchingExperts: 'Matching only',
		matchesYourCompany: 'Matches your Junior Company according to their profile.',
		notOpenForNewCompanies: 'Not accepting new Junior Companies at the moment.',
		reachableVia: 'Reachable: {{modes}}',
		ownExpertsLegacyNote:
			'You created these entries yourselves, holding data about a person who did not know about it at first. Nothing can be added here any more: invite the person via “Invite expert” instead, so they enter their own details and give their own consent. Entries nobody confirmed are deleted automatically on the date shown.',
		expertRecordRemovedTitle: 'Self-entered record deleted',
		expertRecordRemovedText:
			'The record for {{name}} was deleted: the person did not confirm the data held about them within {{days}} days. To keep working with them, invite them under “Economic experts”.',
		deletedOn: 'Deleted on {{date}}',
		viewMode: 'View',
		viewRows: 'Rows',
		viewTiles: 'Tiles',
		requestSent: 'Request sent',
		requestSentFor: 'Request sent for {{company}}',
		supporterCompanyScopeHint: 'Requests, connections and suggestions always apply to this Junior Company.',
		supporterRequestByStudentsHint:
			'The students of the Junior Company send the request themselves. You can browse here and recommend experts to them.',
		contactDetails: 'Contact',
		endCollaboration: 'End collaboration',
		endCollaborationTitle: 'End collaboration?',
		endCollaborationText:
			'The collaboration with {{company}} will end. The other side will be notified. A new request is possible at any time.',
		collaborationEnded: 'The collaboration has ended.',
		profileTab: 'Profile',
		collaboration: 'Collaboration',
		aboutPerson: 'About this person',
		sendRequest: 'Send request',
		emailReadOnlyHint: 'Your login address — it cannot be changed here.',
		contactPreferences: 'Availability',
		contactPreferencesOwnHint:
			'Junior Companies see this before they send a request. Your contact details only become visible once you have accepted a request.',
		contactModes: 'Preferred way of contact',
		contactTimes: 'Preferred times',
		contactModeEMAIL: 'E-mail',
		contactModePHONE: 'Phone',
		contactModeVIDEO: 'Video call',
		contactModeON_SITE: 'In person',
		contactModeCHAT: 'Chat / messenger',
		contactTimeWEEKDAY_MORNING: 'Weekdays, mornings',
		contactTimeWEEKDAY_AFTERNOON: 'Weekdays, afternoons',
		contactTimeWEEKDAY_EVENING: 'Weekdays, evenings',
		contactTimeWEEKEND: 'Weekends',
		contactTimeBY_ARRANGEMENT: 'By arrangement',
		contactNote: 'Note on getting in touch',
		contactNotePlaceholder: 'e.g. "E-mail works best, I call back within two days."',
		noContactPreferences: 'This person has not stated any contact preferences.',
		contactHiddenHint: 'Contact details become visible once your request has been accepted.',
		makeRequest: 'Send a request',
		inviteExpert: 'Invite an expert',
		inviteExpertHint:
			'Do you know someone who could support you — from your family, your neighbourhood, an internship? Invite them directly.',
		inviteForCompany: 'For which Junior Company?',
		inviteMessage: 'Personal note (optional)',
		inviteMessagePlaceholder:
			'e.g. "We talked about our project at the parents\' evening — we would love your support."',
		inviteExpertNotice:
			'The person receives an e-mail with a link. As soon as they activate their profile they work with {{company}} — no approval by Junior Achievement is needed. Their profile is visible to you only at first; whether they want to be findable by all Junior Companies is their own decision.',
		sendInvitation: 'Send invitation',
		expertInvited: 'The invitation is on its way',
		invitedByOwnCompany: 'This person was invited by {{company}} and is therefore available to you only.',
		invitedByCompanyOnly:
			'Invited by the Junior Company {{company}} itself. The profile is visible to them only — the person has not switched on general findability.',
		invitedByCompanyOpen:
			'Invited by the Junior Company {{company}} itself. The person is now findable by all Junior Companies.',
		visibleToAllCompanies: 'Findable by all Junior Companies',
		visibleToAllCompaniesOn:
			'Your profile appears in the expert search of every Junior Company. You can still accept or decline each request individually.',
		visibleToAllCompaniesOff: 'Your profile is visible to {{company}} only — the Junior Company that invited you.',
		doesNotMatch:
			'According to their profile this does not match your Junior Company: {{criteria}}. You can still send a request.',
		matchCriterionSTATE: 'federal state',
		matchCriterionINDUSTRY: 'industry',
		matchCriterionSCHOOL_TYPE: 'school type',
		logTab: 'Log',
		supporterCompanyLogHint:
			'What happened between you and this person — request, acceptance, end — and your own notes on it.',
		supporterCompanyLogNoteHint: 'Visible to your Junior Company only. The expert is not notified about it.',
		logForCompany: 'For which Junior Company?',
		noRequestYet: 'No request',
		noCompanyForLog: 'Without a Junior Company there is nothing to note here.',
		noCollaborationYet: 'There is no collaboration with this person yet.',
		collaborationHowItWorks:
			'How it works: you send a request, the expert accepts or declines it. Contact details appear only after an acceptance.',
		requestPendingHint: 'Your request is on its way. Once it is accepted, the contact details appear here.',
		endCollaborationWhen: 'When does this make sense?',
		endCollaborationWhenText:
			'When your project is finished or you no longer need support. For a break there is nothing to end — just get in touch again when you continue.',
		endCollaborationEffect: 'What happens?',
		endCollaborationEffect1: 'The expert receives an e-mail saying the collaboration has ended.',
		endCollaborationEffect2: 'You will no longer see the contact details.',
		endCollaborationEffect3: 'Nothing is deleted — the collaboration is then marked "Ended".',
		endCollaborationEffect4: 'You can send the same person a new request at any time.',
		requestForCompany: 'For which Junior Company?',
		chooseCompany: 'Please select',
		connectionStatusREQUESTED: 'Requested',
		connectionStatusCONNECTED: 'Connected',
		connectionStatusDECLINED: 'Declined',
		connectionStatusENDED: 'Ended',
		acceptRequest: 'Accept',
		declineRequest: 'Decline',
		noSupportersFound: 'No supporters found.',
		noConnectionsYet: 'There are no requests yet.',
		openForNewCompanies: 'Open to new Junior Companies',
		deleteProfile: 'Delete profile',
		deleteProfileHint: 'Your personal data will be anonymised. This step cannot be undone.',
		consentTitle: 'Consent',
		consentGivenAt: 'Given on {{date}}',
		consentGivenAtUnknown: 'No date of consent on record',
		profileDeletedTitle: 'Your profile has been deleted',
		profileDeletedText:
			'You withdrew your consent on {{date}}. Your supporter profile was deleted and your personal data anonymised; schools and students can no longer see you.',
		profileDeletedAgain:
			'If you would like to be available as a supporter again, we would be glad to see you register anew. For questions, write to info@junior.cc.',
		withdrawConsent: 'Withdraw consent',
		withdrawConsentHint:
			'Withdrawing removes the legal basis for the processing: your profile is deleted, your personal data is anonymised and pending requests are ended. Processing carried out before the withdrawal remains lawful. This step cannot be undone.',
		withdrawConsentConfirm:
			'Do you really want to withdraw your consent? This deletes your profile and anonymises your data.',
		withdrawConsentDone: 'Your consent has been withdrawn. Your profile is deleted and your data anonymised.',
		consentWithdrawnTitle: 'Your consent has been withdrawn',
		consentWithdrawnText:
			'Your supporter profile has been deleted, your personal data anonymised and your access closed. We have sent you a confirmation by e-mail.',
		cancelInvitation: 'Withdraw invitation',
		cancelInvitationHint:
			'The pending invitation will be removed. The person will no longer be able to register with it.',
		openRecord: 'Open record',
		allStates: 'All federal states',
		homeState: 'Home federal state',
		editInvitation: 'Edit invitation',
		editInvitationHint:
			'This person does not have a profile yet. Until activation their master data is held on the invitation and can be corrected here.',
		invitationEmailChangedHint:
			'The email address has changed. On saving, the invitation is sent again to the new address and the previous activation link stops working.',
		invitationResentToNewAddress: 'Saved. The invitation has been sent to the new address.',
		invitationOrigin: 'Where this invitation came from',
		invitationSource: 'Invited via',
		invitationSourceADMIN_INVITE: 'Junior Achievement',
		invitationSourceSCHOOL_INVITE: 'Junior Company',
		invitationSourceSELF_REGISTRATION: 'Self-registration',
		invitedByRoleSTUDENT: 'Student',
		invitedByRoleTEACHER: 'Teacher',
		invitedByRoleADMINISTRATOR: 'State admin',
		invitedByRoleFEDERAL_ADMINISTRATOR: 'Federal admin',
		invitedByRoleSUPPORTER: 'Supporter',
		notRecorded: 'not recorded',
		invitationResentButEmailFailed: 'The invitation was renewed, but the email could not be delivered.',
		systemReminded: 'Reminders sent by the system: {{count}}',
		lastReminder: 'last on {{date}}',
		autoDeclinedHint: 'Automatically declined after no reply',
		systemRemindsHint: 'The system reminds the person automatically. You do not need to follow up.',
		gdprConsent:
			'I consent to Junior Achievement Austria processing my profile data in order to match me with Junior Companies and showing it to the schools and students on the platform.',
		gdprConsentDetails:
			'Your name, company, position, short description, fields of expertise and photo become visible — only to signed-in schools and students. Your private contact details (email, phone, address) stay hidden until you accept a request. You can withdraw this consent at any time in your profile; processing carried out before the withdrawal remains unaffected.',
		activateProfile: 'Activate profile',
		supporterRegistration: 'Register as a supporter',
		passwordMinLength: 'The password must be at least 8 characters long.',
		passwordsDoNotMatch: 'The passwords do not match.',
		atLeastOneRole: 'Please select at least one role.',
		emailAlreadyRegistered: 'An account already exists for this email address.',
		alreadyRegistered: 'Already have a profile?',
		wantToSupport: 'Would you like to support Junior Achievement?',
		connectedCompanies: 'Connected Junior Companies',
		connectedCompaniesHint: 'Requests and ongoing engagements of this person, newest first.',
		noConnectedCompanies: 'No Junior Company has sent a request yet.',
		companiesAndNeeds: 'Companies & needs',
		supportRequestResponses: 'Support needs',
		supportRequestResponsesHint: 'Acceptances and declines of this person for published support needs.',
		noSupportRequestResponses: 'This person has not replied to any published support need.',
		requestedOn: 'requested on',
		respondedOn: 'answered on',
		endedOn: 'ended on',
		eventDate: 'Date',
		responseAccepted: 'Accepted',
		responseDeclined: 'Declined',
		logHistory: 'History',
		newLogEntry: 'New entry',
		supporterLogNoteHint: 'The note stays internal unless it is explicitly shared. No notification is sent.',
		supporterLogNotePlaceholder: 'What was discussed, what should be kept in mind?',
		visibleToSupporter: 'Visible to the supporter',
		internalOnly: 'Internal only',
		noLogEntriesYet: 'No entries yet.',
		noteByAdmin: 'Note by the administration',
		noteBySupporter: 'Entry by the supporter',
		noteByMe: 'My entry',
		supporterOwnNotesHint:
			'Keep track of what matters for your collaboration here. The administration sees your entries right away. Notes by the administration appear only if they are explicitly shared.',
		supporterOwnNotePlaceholder: 'Your note …',
		supporterLogEventSUPPORTER_REGISTERED: 'Registered themselves',
		supporterLogEventSUPPORTER_INVITE_ACCEPTED: 'Invitation accepted, profile created',
		supporterLogEventSUPPORTER_APPROVED: 'Profile approved',
		supporterLogEventSUPPORTER_STATUS_CHANGED: 'Status changed',
		supporterLogEventSUPPORTER_ANONYMIZED: 'Profile deleted (anonymised)',
		supporterLogEventSUPPORTER_CONSENT_WITHDRAWN: 'Consent withdrawn (profile anonymised)',
		supporterLogEventSUPPORTER_ROLES_CHANGED: 'Roles changed',
		supporterLogEventSUPPORTER_COMPETENCES_CHANGED: 'Competences changed',
		supporterLogEventSUPPORTER_TARGET_GROUPS_CHANGED: 'Target audience changed',
		supporterLogEventSUPPORTER_PROFILE_UPDATED: 'Profile changed',
		supporterLogEventCONNECTION_REQUESTED: 'Junior Company sent a request',
		supporterLogEventCONNECTION_ACCEPTED: 'Request accepted',
		supporterLogEventCONNECTION_DECLINED: 'Request declined',
		supporterLogEventCONNECTION_AUTO_DECLINED: 'Request declined automatically without an answer',
		supporterLogEventCONNECTION_ENDED: 'Collaboration ended',
		supporterLogEventCONNECTION_ENDED_BY_COMPANY: 'Collaboration ended by the Junior Company',
		supporterLogEventSUPPORT_REQUEST_ACCEPTED: 'Accepted a support need',
		supporterLogEventSUPPORT_REQUEST_DECLINED: 'Declined a support need',
		specializations: 'Specialisations',
		uploadPicture: 'Upload picture',
		changePicture: 'Change picture',
		avatarHint: 'JPG, PNG or GIF, up to 5 MB.',
		avatarWrongType: 'Please choose an image in JPG, PNG or GIF format.',
		avatarTooLarge: 'The image is larger than 5 MB.',
		editPicture: 'Crop picture',
		avatarEditorHint: 'Drag the image into the frame, resize it with the slider and rotate it if needed.',
		'Cover image': 'Cover image',
		'No cover image': 'No cover image',
		'Upload cover image': 'Upload cover image',
		'Change cover image': 'Change cover image',
		'Crop cover image': 'Crop cover image',
		coverImageHint: 'JPG, PNG or GIF, up to 5 MB. The crop is 16:9 (landscape).',
		coverEditorHint:
			'Drag the image into the frame, resize it with the slider and rotate it if needed. The 16:9 crop is what gets saved.',
		'Image set': 'Image present',
		'The message was saved, but the cover image was not transferred.':
			'The message was saved, but the cover image was not transferred.',
		applyPicture: 'Apply',
		rotateLeft: 'Rotate left',
		rotateRight: 'Rotate right',
		resetImage: 'Reset',
		zoom: 'Size',
		zoomIn: 'Zoom in',
		zoomOut: 'Zoom out',
		requestMessage: 'What would you like support with?',
		requestMessagePlaceholder:
			'We would appreciate support in the following areas: … (e.g. pricing, marketing, preparing for the sales day)',
		requestMessageMissing: 'Please describe it in a bit more detail – {{count}} more characters.',
		requestMessageHint: 'The expert sees your text together with your business idea.',
		requestCompetencesLabel: 'Which competences would you like support with? (optional)',
		requestNextStepHint:
			'What happens next: The expert sees your request and accepts or declines. If they accept, you get a notification and an e-mail with their contact details – then it is your turn to get in touch.',
		requestNextStepHintDays:
			'What happens next: The expert sees your request and accepts or declines. If they accept, you get a notification and an e-mail with their contact details – then it is your turn to get in touch within {{days}} days.',
		connectionBusinessIdea: 'Business idea',
		connectionRequestNeed: 'The Junior Company would like support with',
		connectionRequestCompetences: 'Competences addressed',
		connectionNextStepTitle: 'What happens if you accept?',
		connectionNextStepText:
			'The Junior Company will then see your contact details and get in touch within {{days}} days – preferably by {{modes}}, as stated in your profile. Your contact details stay hidden until you accept. Declining is perfectly fine and helps the Junior Company find someone else quickly.',
		connectionNextStepTextNoModes:
			'The Junior Company will then see your contact details and get in touch within {{days}} days. Your contact details stay hidden until you accept. Declining is perfectly fine and helps the Junior Company find someone else quickly.',
		connectionContactConfirmed: 'On {{date}} the Junior Company confirmed that you are in touch.',
		listOr: '{{first}} or {{last}}',
		supporterAcceptedTitle: '{{name}} has accepted',
		supporterAcceptedText:
			'Great news: {{name}} is supporting your Junior Company “{{company}}”! Now it is your turn – please get in touch within {{days}} days, i.e. by {{until}}.',
		supporterAcceptedModes: 'The best way to reach {{name}} is by {{modes}}.',
		supporterAcceptedTip:
			'Briefly introduce yourselves, explain what you are working on and suggest a first meeting.',
		supporterAcceptedTeacherTitle: 'Business expert has accepted',
		supporterAcceptedTeacherText:
			'{{name}} has accepted the request of the Junior Company “{{company}}”. The students are asked to contact the expert within {{days}} days – by {{until}}. After that, the Junior Database asks them whether contact has been made.',
		toExperts: 'To the business experts',
		contactCheckTitle: 'Have you contacted {{name}} yet?',
		contactCheckText: 'On {{date}} {{name}} agreed to support your Junior Company “{{company}}”.',
		contactCheckTextPromised: 'You wanted to get in touch with {{name}} by {{date}}.',
		contactCheckQuestion: 'Have you been in touch yet?',
		contactCheckYes: 'Yes, we are in touch',
		contactCheckNo: 'Not yet',
		contactCheckPromise: 'We will contact {{name}} {{reach}} within the next … days:',
		contactCheckDays: '{{count}} days',
		contactCheckDay: '1 day',
		contactCheckSubmit: 'Confirm',
		contactCheckAnsweredYes: 'Thank you! {{by}} confirmed that you are in touch with {{name}}.',
		contactCheckAnsweredNo: 'Thank you! You will get in touch with {{name}} by {{date}} – we will ask again then.',
		contactCheckSomeone: 'Someone from your team',
		notOpenForNewCompanies: 'This expert is currently not accepting new Junior Companies.',
		personalData: 'Personal data',
		personalDataAndCompany: 'Personal data & company',
		rolesAndCompetences: 'Roles & competences',
		targetAudience: 'Target audience',
		targetAudienceHint:
			'Schools and Junior Companies filter by these criteria. Without a selection there is no restriction — the profile then shows up in every result.',
		currentStatus: 'Current status',
		currentlySet: 'current',
		statusExplained: 'What the statuses mean',
		sectionPerson: 'Person',
		sectionCompany: 'Professional',
		profileAndAvailability: 'Short profile & availability',
		openForNewCompaniesHint: 'When ticked, Junior Companies can send new requests to this person.',
		rolesHint: 'At least one role is required. It determines what the person is asked for.',
		supporterRoleHintEXPERT: "Supports Junior Companies with expertise and appears in the schools' search.",
		supporterRoleHintJURY: 'Assesses Junior Companies at competitions and trade fairs.',
		supporterRoleHintTRAINER: 'Runs trainings and workshops for students and teachers.',
		furtherCompetencesHint: 'Freely entered competences outside the catalogue. Click an entry to remove it.',
		addCompetence: 'Add',
		removeCompetence: 'Remove',
		selectedCount: '{{count}} selected',
		noRestriction: 'No restriction',
		clearSelection: 'Clear selection',
		staleTargetValues: 'These values are not part of the maintained lists. Click an entry to remove it.',
		removeStaleValue: 'Remove',
		unsavedChanges: 'Unsaved changes',
		supporterStatusHintINVITED:
			'The invitation has been sent, but the person has not created their profile yet. Not visible to schools.',
		supporterStatusHintPENDING_APPROVAL:
			'The person registered themselves and is waiting for approval by the administration. Not visible to schools until then.',
		supporterStatusHintACTIVE:
			"The profile is approved. Experts then appear in the schools' search and can be contacted by Junior Companies.",
		supporterStatusHintUNAVAILABLE:
			'Temporarily unavailable, for example due to holidays or workload. The account remains, but the profile does not appear in search results.',
		supporterStatusHintARCHIVED:
			'Archived by the administration: invisible to schools, but the data is retained and can be set active again at any time.',
		supporterStatusHintDELETED:
			'The personal data has been anonymised on request (GDPR). This step cannot be undone.',
		setActive: 'Set active',
		setUnavailable: 'Set unavailable',
		archiveProfile: 'Archive profile',
		registrationPending: 'Thank you! Your profile will be reviewed by the administration and activated afterwards.',
		uploadBP: 'Upload business Plan',
		companyEmployees: 'Company Employees',
		news: 'News',
		event: 'Event',
		genders: 'Genders',
		'School Types': 'School Types',
		'VAT Rates Revenues': 'VAT Rates Revenues',
		'VAT Rates Expenditure': 'VAT Rates Expenditure',
		'Work Areas': 'Work Areas',
		'Type of Offers': 'Type of Offers',
		'Shareholder Shares': 'Shareholder Shares',
		'Max. Share Amounts': 'Max. Share Amounts',
		'Share Amounts': 'Share Amounts',
		CEO: 'CEO',
		'Not CEO': 'Not CEO',
		'Crop image': 'Crop image',
		'Junior Insurance': 'Junior Insurance',
		'Reports deadline': 'Reports deadline',
		'Invoices overdue time': 'Invoices overdue time',
		'Bank Data': 'Bank Data',
		'No news yet': 'No news yet',
		'No shares yet': 'No shares yet',
		'No reports yet': 'No reports yet',
		'Supervision Teacher': 'Supervision Teacher',
		Report: 'Report',
		Registration: 'Registration',
		'BUSINESS ACTIVITIES': 'BUSINESS ACTIVITIES',
		'Basic Info': 'Basic Info',
		'Company name': 'Company name',
		'The company name can only be changed by the JAA administration.':
			'The company name can only be changed by the JAA administration.',
		Note: 'Note',
		'Company type': 'Company type',
		state: 'State',
		save: 'Save',
		contacts: 'Contacts',
		'Company email': 'Company email',
		// CompanyEmailDescriptionAttention: `Important: The email address must be verified by JAA before your company profile can be activated.`,
		CompanyEmailDescription: `<highlight>Note:</highlight> The company contact email address must be verified <highlight>before submitting the company for approval</highlight>. It should be used for communication with external stakeholders and customers and must always be listed on the website and in invoices. Free providers such as <highlight>gmx.at</highlight>, <highlight>gmail.com</highlight>, or <highlight>icloud.com</highlight> can be used to set one up if a company email address is not yet available.3Note: The company contact email address must be verified before submitting the company for approval. It should be used for communication with external stakeholders and customers and must always be listed on the website and in invoices. Free providers such as gmx.at, gmail.com, or icloud.com can be used to set one up if a company email address is not yet available.`,
		phone: 'Phone',
		phoneDesc: `The company phone number may be used for communication with external partners and may also appear on your website or on invoices.`,
		school: 'School',
		schoolDesc:
			'The JUNIOR Company will be registered at your school location. Please choose an already registered school or enter a new school location.',
		teacherDesc:
			'Please select an already registered JUNIOR teacher. If your teacher is not yet registered with us: register a new teacher here!',
		'Business Activity': 'Business Activity',
		branch: 'Branch',
		description: 'Description',
		descriptionNote:
			'The JUNIOR Company will be registered at your school location. Please choose an already registered school or enter a new school location.',
		typeOffers: 'Type of offers',
		typeOffersNote:
			'Please select an already registered JUNIOR teacher. If your teacher is not yet registered with us: register a new teacher here!',
		descriptionPlaceholder: 'Type short company description',
		'Business Idea': 'Short description of the business idea',
		'Your Business Idea': 'Short description of your business idea',
		'Business idea purpose': 'Used for the commercial register extract and the presentation in the JAA portal.',
		'We are the...': 'We are the...',
		'Symbols Left': 'Symbols Left',
		Characters: 'Characters',
		Symbols: 'Symbols',
		'Characters left': '{{left}} of {{max}} characters left',
		'Characters over limit': '{{over}} characters over the limit of {{max}} — please shorten',
		'Character limit': 'At most {{max}} characters',
		'Pasted text shortened':
			'The pasted text was too long and has been shortened by {{cut}} characters — no more than {{max}} characters are possible.',
		'Our...': 'Our...',
		'Select Branch': 'Select Branch',
		'Company Employee': 'Company Employee',
		'Go back': 'Go back',
		'Add Expert': 'Add Expert',
		'Company Documents': 'Company Documents',
		EMPLOYEE: 'EMPLOYEE',
		'Company Shares': 'Shareholders',
		Shareholder: 'Shareholder',
		'Shareholder details': 'Shareholder',
		'Shares sold': 'Shares sold',
		'Signed on': 'Signed on',
		'Consent document hint':
			'The uploaded consent for the purchase of the share. It is also filed with the documents of the Junior Company.',
		'Download consent document': 'Download consent document',
		'Delete shareholder': 'Delete shareholder',
		'The shareholder and the uploaded consent document will be deleted.':
			'The shareholder and the uploaded consent document will be deleted. The share certificate that was already issued stays with the documents.',
		'Shareholder has been removed successfully.': 'The shareholder has been deleted.',
		'No shareholders yet': 'No shareholders yet',
		'Shareholders admin hint':
			'Who bought shares of this Junior Company. Shareholders are added and deleted by the Junior Company itself; click an entry for contact details and the consent document.',
		'No shareholders yet hint':
			'As soon as the Junior Company sells shares, the buyers appear here — with share, contact details and consent document.',
		shareholdersDesc:
			'All capital investors must be registered with their first and last name and a valid address. As soon as this data is complete, the investor will receive a personal certificate of participation in your Junior Company by e-mail. Please make sure that all data is correct at the first entry, later',
		Important: 'Important',
		salutation: 'Salutation',
		'Title Prefixed': 'Title prefixed',
		'First Name': 'First name',
		'Last Name': 'Last name',
		'Title Suffixed': 'Title suffixed',
		gender: 'Gender',
		'Select the amount': 'Select the amount',
		'Company Share': 'Company Share',
		'Warrant Upload': 'Warrant Upload',
		'Please upload the warrant!': 'Please upload the warrant!',
		'Shareholder Phone': 'Shareholder Phone',
		'House number': 'House number',
		'Zip Code': 'Zip Code',
		City: 'City',
		'Type First Name': 'Type First Name',
		'Enter Title': 'Enter Title',
		'Type Last Name': 'Type Last Name',
		'Select Gender': 'Select Gender',
		SHAREHOLDER: 'SHAREHOLDER',
		'Market and Risk Analysis': 'Market and Risk Analysis',
		'Market Description': 'Market Description',
		'To market description': 'To market description',
		'Target group(s)': 'Target group(s)',
		'Product usage': 'Product usage',
		'Add usage...': 'Add usage...',
		'To product benefit': 'To product benefit',
		'Describe your target group(s) as precisely as possible with their specific characteristics, such as age group, life situation, interests, whereabouts, etc.':
			'Describe your target group(s) as precisely as possible with their specific characteristics, such as age group, life situation, interests, whereabouts, etc.',
		'What added value does your offer bring to the target group, what needs does it serve? For what benefit does the customer pay the purchase price?':
			'What added value does your offer bring to the target group, what needs does it serve? For what benefit does the customer pay the purchase price?',
		'Customer contact, sales strategy': 'Customer contact, sales strategy',
		'Where is/are your target group(s) to be found? How do you promote your offer to the respective target group? Which communication channels do you use?':
			'Where is/are your target group(s) to be found? How do you promote your offer to the respective target group? Which communication channels do you use?',
		'Add contact & Strategy': 'Add contact & Strategy',
		'Sales forecast': 'Sales forecast',
		'Enter your expected sales figures for your up to 5 most important offers and their respective prices. This will give you a forecast of your sales for the entire project year.':
			'Enter your expected sales figures for your up to 5 most important offers and their respective prices. This will give you a forecast of your sales for the entire project year.',
		'Product / Service': 'Product / Service',
		'Product name': 'Product name',
		'Price (€) / unit': 'Price (€) / unit',
		'Expected sales (number)': 'Expected sales (number)',
		'Expected turnover (€)': 'Expected turnover (€)',
		'Add new forecast': 'Add new forecast',
		'The total amount of estimated annual sales is €.': 'The total amount of estimated annual sales is €.',
		'Risk and strategy': 'Risk and strategy',
		'Enter here possible risks affecting your company and describe a strategy for dealing with the risk in each case. Risks can arise, for example, in connection with your production, with the target group, with suppliers or with the competition.':
			'Enter here possible risks affecting your company and describe a strategy for dealing with the risk in each case. Risks can arise, for example, in connection with your production, with the target group, with suppliers or with the competition.',
		Risk: 'Risk',
		'Avoidance strategy': 'Avoidance strategy',
		'Add avoidance strategy': 'Add avoidance strategy',
		'Add new Risk': 'Add new Risk',
		'Date of Birth': 'Date of Birth',
		age: 'Age',
		birthdayAgeHint:
			'The age is needed to assess parental consent, for anonymous reporting, and for issuing the certificate.',
		studentCount: 'Number of students',
		'Letter has been sent to confirm email changes.': 'Letter has been sent to confirm email changes.',
		'Your email': 'Your email',
		'Change email': 'Change email',
		'Profile has been updated successfully.': 'Profile has been updated successfully.',
		'Avatar photo': 'Avatar photo',
		'Upload profile photo': 'Upload profile photo',
		'Parental Confirmation': 'Parental Confirmation',
		'Course Certificate': 'Course certificate',
		'Course certificate': 'Course certificate',
		active: 'active',
		'Requirement name': 'Requirement name',
		'Requirement name (German)': 'Requirement name (German)',
		'Requirement name (English)': 'Requirement name (English)',
		'Course link': 'Course link',
		Requests: 'Requests',
		'Company types': 'Company types',
		'To the course': 'To the course',
		'Minimum of 2 students as employees': 'Minimum of 2 students as employees',
		'Minimum of 1 business expert assigned': 'Minimum of 1 business expert assigned',
		'The company was rejected successfully': 'The company was rejected successfully',
		'The parental confirmation was rejected successfully': 'The parental confirmation was rejected successfully',

		// Settings: document templates
		'All PDF documents the application generates: certificates, invoices, confirmations. Each template can be viewed with real data — up to ten records to leaf through. The templates themselves are part of the application and cannot be edited here.':
			'All PDF documents the application generates: certificates, invoices, confirmations. Each template can be viewed with real data — up to ten records to leaf through. The templates themselves are part of the application and cannot be edited here.',
		'Example: the participation certificate — pick a real company, look at the PDF, download it if needed.':
			'Example: the participation certificate — pick a real company, look at the PDF, download it if needed.',

		// Settings: tabs
		'Checklist & requirements': 'Checklist & requirements',
		Taxes: 'Taxes',
		'Bank details': 'Bank details',

		// Requirements: checklist wording (as students read it)
		'Your company profile and your risk analysis must be filled in completely':
			'Your company profile and your risk analysis must be filled in completely',
		'Your company needs at least two registered students as employees':
			'Your company needs at least two registered students as employees',
		'Your company needs at least one business expert': 'Your company needs at least one business expert',
		'All parental consent forms must be available signed and checked by the administration':
			'All parental consent forms must be available, signed and checked by the administration',
		'All employees confirmed, pending invitations deleted': 'All employees confirmed, pending invitations deleted',
		'Every employee must have been assigned a function': 'Every employee must have been assigned a function',
		'The official email address of your company must be verified':
			'The official email address of your company must be verified',
		'To the risk analysis': 'To the risk analysis',
		'To the employees': 'To the employees',
		'To the business experts': 'To the business experts',
		'To your profile': 'To your profile',
		'To the company profile': 'To the company profile',

		// Requirements: configuration
		'Configure requirements': 'Configure requirements',
		'Every item of the checklist above with its setting. Switched off, it disappears from the students’ checklist and is no longer required for submission.':
			'Every item of the checklist above with its setting. Switched off, it disappears from the students’ checklist and is no longer required for submission.',
		'Example: if no experts are needed in a given year, switch off that item — it then disappears from the checklist.':
			'Example: if no experts are needed in a given year, switch off that item — it then disappears from the checklist.',
		'A switched-off requirement is no longer checked before submission. It disappears from the checklist above at once — including for companies that are currently filling it in.':
			'A switched-off requirement is no longer checked before submission. It disappears from the checklist above at once — including for companies that are currently filling it in.',
		'Switched off and therefore not shown to students': 'Switched off and therefore not shown to students',
		'These conditions must be met before a Junior Company can be submitted for review and activated. Which of them apply is set in the card below.':
			'These conditions must be met before a Junior Company can be submitted for review and activated. Which of them apply is set in the card below.',
		'Additional requirement': 'Additional requirement',
		activated: 'activated',
		deactivated: 'deactivated',

		// Settings: link to the template a setting triggers
		'Related template': 'Related template',
		'Related templates': 'Related templates',
		'switched off': 'switched off',

		// Settings: submenu
		'Settings sections': 'Settings sections',

		// Settings: requirements for activation
		'Checklist as students see it': 'Checklist as students see it',
		'A student sees this list when clicking "Submit for review". Submitting is only possible once every item is met.':
			'A student sees this list when submitting their company for review. Submitting is only possible once every item is met.',
		'Applies to': 'Applies to',
		'Example: the LinkedIn certificate for the Gen AI course. Switched on, it becomes an extra item in the checklist above; switched off, students never see it.':
			'Example: the LinkedIn certificate for the Gen AI course. Switched on, it becomes an extra item in the checklist above; switched off, students never see it.',
		'Without a company type ticked the condition has no effect — it then applies to no company at all.':
			'Without a company type ticked the condition has no effect — it then applies to no company at all.',
		'The condition only applies to the company types ticked here.':
			'The condition only applies to the company types ticked here.',

		// Settings: company presentation
		'From which stage of processing a Junior Company appears on the public overview page. The stages build on one another: everything from the selected stage onwards is shown.':
			'From which stage of processing a Junior Company appears on the public overview page. The stages build on one another: everything from the selected stage onwards is shown.',
		'Example: "From submission for review onwards" shows companies awaiting a decision as well as activated ones — but not those still being edited.':
			'Example: "From submission for review onwards" shows companies awaiting a decision as well as activated ones — but not those still being edited.',
		'Affects the public overview page only. Inside the application every role keeps seeing the companies it is entitled to see.':
			'Affects the public overview page only. Inside the application every role keeps seeing the companies it is entitled to see.',
		'Publish companies from this stage onwards': 'Publish companies from this stage onwards',
		'Only after activation': 'Only after activation',
		'From submission for review onwards': 'From submission for review onwards',
		'From registration onwards': 'From registration onwards',
		'Only the company types ticked here appear on the public overview page.':
			'Only the company types ticked here appear on the public overview page.',
		'Please select at least one company type': 'Please select at least one company type',
		'Please select': 'Please select',

		// Settings: invoices overdue
		'Number of days after the invoice date from which an invoice counts as overdue. It controls the status shown in the dashboard and in the invoice list, and it starts the payment reminders.':
			'Number of days after the invoice date from which an invoice counts as overdue. It controls the status shown in the dashboard and in the invoice list, and it starts the payment reminders.',
		'Example: 30 — an invoice issued on 1 March counts as overdue from 31 March.':
			'Example: 30 — an invoice issued on 1 March counts as overdue from 31 March.',
		'Takes effect immediately for all existing invoices: lowering the number can mark many invoices as overdue at once.':
			'Takes effect immediately for all existing invoices: lowering the number can mark many invoices as overdue at once.',
		'What happens once the deadline has passed': 'What happens once the deadline has passed',
		'The invoice is listed as "Overdue" in the dashboard, in the invoice list and in the company overview.':
			'The invoice is listed as "Overdue" in the dashboard, in the invoice list and in the company overview.',
		'First payment reminder {{days}} days after the invoice date — but never before the invoice is actually overdue.':
			'First payment reminder {{days}} days after the invoice date — but never before the invoice is actually overdue.',
		'First payment reminder as configured under "Invoicing Reminders" — but never before the invoice is actually overdue.':
			'First payment reminder as configured under "Invoicing Reminders" — but never before the invoice is actually overdue.',
		'Repeated every {{days}} days for as long as the invoice remains unpaid.':
			'Repeated every {{days}} days for as long as the invoice remains unpaid.',
		'Repeated at the interval configured under "Invoicing Reminders".':
			'Repeated at the interval configured under "Invoicing Reminders".',
		'Every student of the company receives the reminder by email; the company and its supervising teacher additionally get a message inside the application.':
			'Every student of the company receives the reminder by email; the company and its supervising teacher additionally get a message inside the application.',
		'Invoices are checked once a night at 3:00 a.m. A reminder therefore goes out in the night after the deadline has passed at the earliest, and each invoice is only reminded once per run.':
			'Invoices are checked once a night at 3:00 a.m. A reminder therefore goes out in the night after the deadline has passed at the earliest, and each invoice is only reminded once per run.',

		'click for open file': 'click for open file',
		ParentalDesc:
			'	The e-mail address of the company is used for contact with the JUNIOR Company and functions as a login to the database. If your company does not yet have an e-mail address, you can create one for your company free of charge at providers such as gmx.at, gmail.com or icloud.com.',
		'Residential address': 'Residential address',
		'Your contact data will only be used for our communication with you and will not be passed on to third parties!':
			'Your contact data will only be used for our communication with you and will not be passed on to third parties!',
		'Main function': 'Main function',
		'Your main work area': 'Your main work area',
		'Work area': 'Additional work area',
		'Your work area': 'Your work area',
		'2nd work area': '2nd work area',
		'3rd work area': '3rd work area',
		'Passsword has been changed successfuly.': 'Passsword has been changed successfuly.',
		'Change PW section': 'Change PW section',
		'Old password': 'Old password',
		'New password': 'New password',
		'Repeat new password': 'Repeat new password',
		'Change Password': 'Change Password',
		'My Profile': 'My Profile',
		'The expert was': 'The expert was',
		updated: 'updated',
		created: 'created',
		successfully: 'successfully',
		'Update economic expert': 'Update economic expert',
		'Add economic expert': 'Add economic expert',
		Company: 'Company',
		'Function, position': 'Function, position',
		update: 'Update',
		Cancel: 'Cancel',
		'Add Employee': 'Add Employee',
		'Invitation was sent successfully': 'Invitation was sent successfully',
		'CEO Updated': 'CEO Updated',
		'Send email to all users': 'Send email to all users',
		You: 'You',
		Employee: 'Employee',
		Director: 'Director',
		'Assign managing director (CEO)': 'Assign managing director (CEO)',
		'Invite new employee by Email': 'Invite new employee by Email',
		'Employee Email': 'Employee Email',
		'Teacher added successfully': 'Teacher added successfully',
		'Invite deleted successfully': 'Invite deleted successfully',
		'Lehrer erfolgreich aus Ihrem Unternehmen gelöscht': 'Lehrer erfolgreich aus Ihrem Unternehmen gelöscht',
		'Invite Teacher': 'Invite Teacher',
		Student: 'Student',
		Teacher: 'Teacher',
		Pending: 'Pending',
		Invited: 'Invited',
		'The employee was deleted successfully': 'The employee was deleted successfully',
		'Employee successfully deleted': 'Employee successfully deleted',
		Remove: 'Remove',
		'Select teacher': 'Select teacher',
		Verified: 'Verified',
		Send: 'Send',
		'Teacher Email': 'Teacher Email',
		'Or invite new teacher by Email': 'Or invite new teacher by Email',
		'You can create first report after Company activation': 'You can create first report after Company activation',
		'Risk Analysis Form': 'Risk Analysis Form',
		'Go To Reports': 'Go To Reports',
		'Go To Shares': 'Go To Shares',
		'Go To News': 'Go To News',
		'Events and news': 'Events and news',
		'Go To Companies': 'Go To Companies',
		'Sign In': 'Sign In',
		'Do not have account yet?': 'Do not have account yet?',
		SignUp: {
			noun: 'Sign Up',
			verb: 'Sign Up'
		},
		Password: 'Password',
		'Your password': 'Your password',
		'Forgot password?': 'Forgot password?',
		'Recover Pass': 'Recover Password',
		'A letter with a link to reset the password is sent to the e-mail':
			'A letter with a link to reset the password is sent to the e-mail',
		'Back to': 'Back to',
		page: 'page',
		Recover: 'Recover',
		'Password changed successfully !': 'Password changed successfully !',
		'Successfully updated': 'Successfully updated',
		'Password Recovery': 'Password Recovery',
		'Set password for your new account': 'Set password for your new account',
		'Create a new password': 'Create a new password',
		'Expert Activation': 'Expert Activation',
		'Account confirmation is in progress. Loading...': 'Account confirmation is in progress. Loading...',
		'account successfully activated': 'account successfully activated',
		Activated: 'Activated',
		'Token is not founded': 'Token is not founded',
		'Account confirmation': 'Account confirmation',
		Dashboard: 'Dashboard',
		'Go to': 'Go to',
		'Registration was successful. Please sign in': 'Registration was successful. Please sign in',
		'Registration was successful. Please confirm email': 'Registration was successful. Please confirm email',
		'as student account': 'as student account',
		'Have account?': 'Have account?',
		Role: 'Role',
		'Repeat password': 'Repeat password',
		'I agree that the above data will be collected and stored by Junior Achievement Austria for the duration of this school year for the purpose of fulfilling and processing the Junior Project. These data will not be passed on to third parties by Junior Achievement Austria and will be removed from the database after the end of the school year.':
			'I agree that the above data will be collected and stored by Junior Achievement Austria for the duration of this school year for the purpose of fulfilling and processing the Junior Project. These data will not be passed on to third parties by Junior Achievement Austria and will be removed from the database after the end of the school year.',
		'Step 2': 'Step 2',
		'Provide your personal details': 'Provide your personal details',
		'Select salutation': 'Select salutation',
		'Select gender': 'Select gender',
		Back: 'Back',
		Continue: 'Continue',
		Submit: 'Submit',
		'Create Company': 'Create Company',
		'Choose company Type': 'Choose company Type',
		'Classical Junior Company for 15-19 year old students. Duration 1 school year (2 semesters)':
			'Classical Junior Company for 15-19 year old students. Duration: 1 school year (2 semesters)',
		'Simplified Junior Company for 7th-9th grade. Duration 1 semester. Simplified Accounting.':
			'Simplified Junior Company for 7th-9th grade. Duration: 1 semester. Simplified Accounting.',
		'Shortened Junior Company for 9th-13th grade students. Can be done in 1 semester.':
			'Shortened Junior Company for 9th-13th grade students. Can be done in 1 semester.',
		Create: 'Create',
		'Provide us company data': 'Provide us company data',
		'Company state': 'Company state',
		'Type Short Company Description': 'Type Short Company Description',
		'Hello, welcome back': 'Hello, welcome back',
		'Edit My Profile': 'Edit My Profile',
		'Supervision MaleTeacher in': 'Supervision Teacher in',
		'Supervision FemaleTeacher in': 'Supervision Teacher in',
		'Supervised Companies': 'Supervised Companies',
		'Participating Students': 'Participating Students',
		'Full list': 'Full list',
		'No companies yet': 'No companies yet',
		'All Students In School': 'All Students In School',
		'No students yet': 'No students yet',
		'ASSIGNED COMPANIES': 'ASSIGNED COMPANIES',
		'Search companies...': 'Search companies...',
		'Search messages...': 'Search messages...',
		'Search templates...': 'Search templates...',
		'Assigned Students': 'Assigned Students',
		'Search for a student': 'Search for a student',
		'Registration Date': 'Registration Date',
		Certificate: 'Certificate',
		Insurance: 'Insurance',
		'Business Plan': 'Business Plan',
		'Search for documents...': 'Search for documents...',
		Type: 'Type',
		'Contacts updated': 'Contacts updated',
		'Change contacts': 'Change contacts',
		Select: 'Select',
		'Change School': 'Change School',
		'General Info': 'General Info',
		Customise: 'Customise',
		'Quick Lists': 'Quick Lists',
		'Last Companies': 'Last Companies',
		'Last Students': 'Last Students',
		'Last Teachers': 'Last Teachers',
		'Available widgets': 'Available Widgets',
		'Max number of widgets is 8': 'Max number of widgets is 8',
		'Widgets updated': 'Widgets updated',
		Members: 'Members',
		member: 'member',
		SCHOOL: 'SCHOOL',
		BaLance: 'Balance',
		Registered: 'Registered',
		'Download list as': 'Download list as:',
		'Download selection as': 'Download selection as:',
		'Files (ZIP)': 'Files (ZIP)',
		documentsZipTooMany:
			'The selection contains {{count}} documents – a ZIP can hold at most {{max}}. Please narrow it down by document type or company.',
		documentsExportFailed: 'The file could not be created. Please try again.',
		'Create School': 'Create School',
		'Update School': 'Update School',
		'Find a school': 'Find a school',
		Result: 'Result',
		from: 'from',
		'Find a user': 'Find a user',
		AMOUNT: 'AMOUNT',
		'Search a invoice': 'Search a invoice',
		'Invoices, total': 'Total',
		'Invoices, paid': 'Paid',
		'Invoices, open': 'Open',
		invoicesCountOf: '{{n}} of {{total}} invoices',
		invoicesOverdueNote: 'thereof {{n}} overdue',
		invoicesCreditNote: 'thereof {{n}} credit notes totalling {{amount}}',
		invoicesCreditNoteOne: 'thereof 1 credit note of {{amount}}',
		invoicesCardHint: 'Click to filter — click again to clear the filter',
		'Invoices, cancelled': 'Cancelled',
		invoicesCancelledCount: '{{n}} cancelled invoices',
		invoicesCancelledCountOne: '1 cancelled invoice',
		invoicesCancelledNote: 'not included in the totals',
		// Credit left on a cancelled invoice that was already paid (#91).
		invoicesOpenCreditNote: 'not included in the totals · {{amount}} credit from {{n}} paid',
		invoicesOpenCreditNoteOne: 'not included in the totals · {{amount}} credit from 1 paid',
		'Credit from cancellation': 'Credit from cancellation',
		invoiceCreditOpenHint:
			'This invoice had been paid. The amount remains as a credit and is applied to the next invoice for this report.',
		invoiceCreditAppliedHint: 'A credit from a cancelled invoice has been applied to this invoice.',
		'Invoice credit applied': 'Credit applied',
		'Invoice credit transferred': 'Credit transferred',
		'Invoice credit open': 'Credit open',
		'Total Invoice Amount': 'Total Invoice Amount',
		'Paid Invoices, %': 'Paid Invoices, %',
		'Paid Invoices': 'Paid Invoices',
		'Overdue Invoices': 'Overdue Invoices',
		'TEMPLATE NAME': 'TEMPLATE NAME',
		'MODIFIED DATE': 'MODIFIED DATE',
		'Email Templates': 'Email Templates',
		Templates: 'Templates',
		'Create Template': 'Create Template',
		'New email template': 'New email template',
		'Template name': 'Template name',
		'Email body': 'Email body',
		'Events & News': 'Events & News',
		// Events & news: card list and dialogs
		Message: 'Message',
		'News entries': 'entries',
		'Message type': 'Message type',
		Messages: 'Messages',
		'Edit message': 'Edit message',
		Duplicate: 'Duplicate',
		'Duplicate message': 'Duplicate message',
		'The copy starts with today and one month ahead — the period of the original is not carried over.':
			'The copy starts with today and one month ahead — the period of the original is not carried over.',
		'The event date of the original is in the past and was not carried over — please enter the new date.':
			'The event date of the original is in the past and was not carried over — please enter the new date.',
		'Sort by': 'Sort by',
		'Newest first': 'Newest first',
		'Oldest first': 'Oldest first',
		'Start date (newest)': 'Start date (newest)',
		'Start date (oldest)': 'Start date (oldest)',
		'Title A–Z': 'Title A–Z',
		'No messages found.': 'No messages found.',
		'No message belongs to the selected company.': 'No message belongs to the selected company.',
		'Show all': 'Show all',
		'Delete message?': 'Delete message?',
		'The message will no longer be shown to anyone. This cannot be undone.':
			'The message will no longer be shown to anyone. This cannot be undone.',
		'Visible to all users': 'Visible to all users',
		// Zielgruppe in der Klammer hinter dem Titel (Zeitachse)
		'for everyone': 'for everyone',
		'only for': 'only for',
		'Check and send': 'Check and send',
		Chronological: 'Chronological',
		'All messages': 'All messages',
		'Period shown': 'Period shown',
		timelineBarHint:
			'The length of a bar shows how long the message is displayed to users on their dashboard. The diamond marks the event date. If it falls outside the period shown, an arrow at the edge points towards it.',
		'outside the period shown': 'outside the period shown',
		months: 'months',
		today: 'today',
		'No messages in this period.': 'No messages in this period.',
		selected: 'selected',
		'No entries': 'No entries',
		Filter: 'Filter',
		'Reset filters': 'Reset filters',
		Reset: 'Reset',
		Close: 'Close',
		Loading: 'Loading',
		Reach: 'Reach',
		'people receive this message': 'people receive this message',
		'Date and time': 'Date and time',
		Address: 'Address',
		History: 'History',
		'The period decides when the message is visible. The status follows from it.':
			'The period decides when the message is visible. The status follows from it.',
		'Display period': 'Display period',
		'Decides when the message appears for students and teachers. The status follows from it.':
			'Decides when the message appears for students and teachers. The status follows from it.',
		'Shown from': 'Shown from',
		'Shown until': 'Shown until',
		Shown: 'Shown',
		'Event date': 'Event date',
		'When it actually takes place — independent of how long it is announced.':
			'When it actually takes place — independent of how long it is announced.',
		'Event start': 'Event start',
		'Event end': 'Event end',
		optional: 'optional',
		'The display period ends before the event takes place.':
			'The display period ends before the event takes place.',
		'The event takes place before the message is shown.': 'The event takes place before the message is shown.',
		'Prefilled with today and one month ahead — adjust as needed.':
			'Prefilled with today and one month ahead — adjust as needed.',
		'Where does it take place? A street address, a link, or both — nothing is required.':
			'Where does it take place? A street address, a link, or both — nothing is required.',
		'Street and number': 'Street and number',
		'Postal code': 'Postal code',
		Country: 'Country',
		'City or town': 'City',
		'Location (previous entry)': 'Location (previous entry)',
		'Also for Teams, Zoom or a registration page.': 'Also for Teams, Zoom or a registration page.',
		'The log starts with its introduction — what happened before is not recorded.':
			'The log starts with its introduction — what happened before is not recorded.',
		'The history cannot be loaded right now.': 'The history cannot be loaded right now.',
		'No changes recorded yet.': 'No changes recorded yet.',
		Created: 'Created',
		Unknown: 'Unknown',
		changed: 'changed',
		empty: 'empty',
		'Reach cannot be determined right now': 'Reach cannot be determined right now',
		'No restriction — all users': 'No restriction — all users',
		'How this message is delivered':
			'After saving, the message appears for the selected target groups under “Events & News” and as a notification inside the Junior database. No email is sent.',
		'Next step': 'Next step',
		'An empty field places no restriction.': 'An empty field places no restriction.',
		'This message reaches': 'This message reaches',
		'all users': 'all users',
		'Not set': 'not set',
		Period: 'Period',
		'The message was created': 'The message was created',
		'The message was updated': 'The message was updated',
		Author: 'Author',
		NEWS: 'News',
		EVENT: 'Event',
		STUDENT: 'Students',
		TEACHER: 'Teachers',
		'Create event': 'Create event',
		Edit: 'Edit',
		'Target groups': 'Target groups',
		Place: 'Place',
		All: 'All',
		'Start date': 'Start date',
		'End date': 'End date',
		'External Link': 'External Link',
		'Add event': 'Add event',
		Title: 'Title',
		'Select state or states': 'Select state or states',
		'User roles': 'User roles',
		'Select role or roles': 'Select role or roles',
		'Select type or types': 'Select type or types',
		'Organization name': 'Organization name',
		'Administrator email': 'Administrator email',
		'Add Administrator': 'Add Administrator',
		Administrators: 'Administrators',
		'Invitation Pending': 'Invitation Pending',
		'The expert was deleted successfully': 'The expert was deleted successfully',
		Accepted: 'Accepted',
		'Companies Pending, %': 'Companies Pending, %',
		Resolve: 'Resolve',
		'Show Invoices': 'Show Invoices',
		'Customize Multi Widget': 'Customize Multi Widget',
		'First Slot': 'First Slot',
		'Second Slot': 'Second Slot',
		'Third Slot': 'Third Slot',
		'Fourth Slot': 'Fourth Slot',
		'Customize Companies Widget': 'Customize Companies Widget',
		New: 'New',
		'You have no notifications at this time': 'You have no notifications at this time',
		'New messages about your company will appear here.': 'New messages about your company will appear here.',
		Today: 'Today',
		Yesterday: 'Yesterday',
		unread: 'unread',
		'To all messages': 'All messages',
		Overdue: 'Overdue',
		Unpaid: 'Unpaid',
		teachers: 'Teachers',
		Turnover: 'Turnover',
		'Confirm Company Profile': 'Confirm Company Profile',
		Documentation: 'Documentation',
		'Business activity empty': 'Business activity empty',
		'Type of offers empty': 'Type of offers empty',
		'Business idea empty': 'Business idea empty',
		'Company Description': 'Company Description',
		'Company description empty': 'Company description empty',
		'Add Admin Comment': 'Add Admin Comment',
		'Your Comment about Company (Only administrators will see this comment)':
			'Your Comment about Company (Only administrators will see this comment)',
		'Type comment about company': 'Type comment about company',
		'Activate Company': 'Activate Company',
		'Annual financial statements': 'Annual financial statements',
		Expenditures: 'Expenditures',
		'Profit/Loss': 'Profit/Loss',
		'To successfully complete the Junior Basic Company the following final accounting must be done.':
			'To successfully complete the Junior Basic Company the following final accounting must be done.',
		Revenue: 'Revenue',
		'Total gross revenue': 'Total gross revenue',
		'All income from your sales WITHOUT income from the sale of Junior Basic Company shares.':
			'All income from your sales WITHOUT income from the sale of Junior Basic Company shares.',
		Expenses: 'Expenses',
		'Total salary expenses': 'Total salary expenses',
		'All expenditures for wages of employees of your Junior Basic Company.':
			'All expenditures for wages of employees of your Junior Basic Company.',
		'Material expenses': 'Material expenses',
		'All expenses for the materials you needed to make your products.':
			'All expenses for the materials you needed to make your products.',
		'Other expenses': 'Other expenses',
		'Other expenses such as transportation or travel expenses, company Christmas party, etc.':
			'Other expenses such as transportation or travel expenses, company Christmas party, etc.',
		'Total gross expenses': 'Total gross expenses',
		Validate: 'Validate',
		Next: 'Next',
		'Profit/Loss was submitted': 'Profit/Loss was submitted',
		'Your income minus expenses result in the profit or loss. Important a loss is written as a minus number!':
			'Your income minus expenses result in the profit or loss. Important: a loss is written as a minus number!',
		'insurance contribution': 'Insurance contribution',
		'Insurance premium for all activities of your Junior Company.':
			'Insurance premium for all activities of your Junior Company.',
		'Net profit/loss': 'Net profit/loss',
		'Profit/loss minus insurance contribution gives the net profit/loss.':
			'Profit/loss minus insurance contribution gives the net profit/loss.',
		'Date of submission (cannot be changed)': 'Date of submission (cannot be changed)',
		Previous: 'Previous',
		'Calculation of profit loss before taxes': 'Calculation of profit loss before taxes',
		'Calculation of corporate income tax': 'Calculation of corporate income tax',
		'Calculation of net profit/loss': 'Calculation of net profit/loss',
		'Calculation of levies to Junior': 'Calculation of levies to Junior',
		'Calculation of profit/loss before taxes was updated': 'Calculation of profit/loss before taxes was updated',
		'To successfully complete the Junior Compact Company the following final financial statement must be made.':
			'To successfully complete the Junior Compact Company the following final financial statement must be made.',
		'Total Income': 'Total Income',
		'Total revenue.': 'Total revenue',
		'All income from your sales and other income WITHOUT income from the sale of Junior Compact Company shares!':
			'All income from your sales and other income WITHOUT income from the sale of Junior Compact Company shares!',
		'Salary expenses': 'Salary expenses',
		'All expenses for wages of employees of your Junior Compact Company ("Entrepreneur`s Wages").':
			'All expenses for wages of employees of your Junior Compact Company ("Entrepreneur`s Wages").',
		'All expenses for materials you needed to produce your products, including sales taxes.':
			'All expenses for materials you needed to produce your products, including sales taxes.',
		'Other expenses such as transportation or travel expenses, company Christmas party, ....':
			'Other expenses such as transportation or travel expenses, company Christmas party, ....',
		'Sum of expenses': 'Sum of expenses',
		'Calculation of profit/loss before taxes': 'Calculation of profit/loss before taxes',
		'Profit/Loss (before tax)': 'Profit/Loss (before tax)',
		'Preliminary profit/loss before deduction of taxes.': 'Preliminary profit/loss before deduction of taxes.',
		'- 13% Salary-related social security contributions': '- 13% Salary-related social security contributions',
		'Depending on the amount of salaries or entrepreneur wages paid, 13% social contributions must be paid.':
			'Depending on the amount of salaries or entrepreneur wages paid, 13% social contributions must be paid.',
		'Salary-related social security contributions': 'Salary-related social security contributions',
		'Insurance contribution': 'Insurance contribution',
		'Insurance contribution for all activities of your Junior Company.':
			'Insurance contribution for all activities of your Junior Company.',
		'Profit/loss (before corporate income tax)': 'Profit/loss (before corporate income tax)',
		'Preliminary profit/loss before deduction of corporate income tax, which is due only in case of profit.':
			'Preliminary profit/loss before deduction of corporate income tax, which is due only in case of profit.',
		'Calculation of corporate income tax was updated': 'Calculation of corporate income tax was updated',
		'25% corporate income tax': '25% corporate income tax',
		'Corporate income tax': 'Corporate income tax',
		'Corporate income is taxed at a fixed rate of 25%.': 'Corporate income is taxed at a fixed rate of 25%.',
		'Founder`s bonus (20% of corporate income tax)': 'Founder`s bonus (20% of corporate income tax)',
		'This represents a tax relief of 20% of the corporate income tax exclusively for junior companies.':
			'This represents a tax relief of 20% of the corporate income tax exclusively for junior companies.',
		'Reduced corporate income tax': 'Reduced corporate income tax',
		'The calculated amount represents the deductible corporate income tax.':
			'The calculated amount represents the deductible corporate income tax.',
		'Calculation of net profit/loss was updated': 'Calculation of net profit/loss was updated',
		'Calculation of net profit/loss (to be distributed)': 'Calculation of net profit/loss (to be distributed)',
		'The reduced corporate income tax is to be deducted from the provisional profit.':
			'The reduced corporate income tax is to be deducted from the provisional profit.',
		'Net profit / Net loss': 'Net profit / Net loss',
		'This amount represents your profit/loss after deduction of taxes.':
			'This amount represents your profit/loss after deduction of taxes.',
		'Calculation of levies to Junior was submitted': 'Calculation of levies to Junior was submitted',
		'Levies to be transferred to Junior Austria': 'Levies to be transferred to Junior Austria',
		'According to this schedule, levies are to be remitted to the account indicated in the invoice.':
			'According to this schedule, levies are to be remitted to the account indicated in the invoice.',
		'+ 13% salary-related social security contributions': '+ 13% salary-related social security contributions',
		'= Taxes to be transferred to Junior Austria': '= Taxes to be transferred to Junior Austria',
		'Revenues and sales': 'Revenues and sales',
		'Expenses and input tax deduction': 'Expenses and input tax deduction',
		'Salary-related taxes (employee share)': 'Salary-related taxes (employee share)',
		'Advance return for sales tax': 'Advance return for sales tax',
		'Calculation half-year result': 'Calculation half-year result',
		'Financial report first semester': 'Financial report first semester',
		'Revenues was deleted': 'Revenues was deleted',
		'Revenues and sales was updated': 'Revenues and sales was updated',
		'Deadline by DD.MM.YYYY': 'Deadline by DD.MM.YYYY',
		'Deadline by': 'Deadline by',
		'Submitted on {{date}}': 'Submitted on {{date}}',
		'Income from the sale of company shares does not count towards your sales!':
			'Income from the sale of company shares does not count towards your sales!',
		'Here you can create new groups of turnovers, with different VAT rates.':
			'Here you can create new groups of turnovers, with different VAT rates.',
		'Turnovers in € incl. VAT': 'Turnovers in € incl. VAT',
		'VAT rate': 'VAT rate',
		'Turnover total': 'Turnover total',
		'of which': 'of which',
		'% VAT in €': '% VAT in €',
		'Create new entry': 'Create new entry',
		'Junior tax-exempt revenues': 'Junior tax-exempt revenues',
		'These revenues do not count towards the calculation of junior corporate tax and do not include VAT - e.g. sponsorship.':
			'These revenues do not count towards the calculation of junior corporate tax and do not include VAT - e.g. sponsorship.',
		'Total in €': 'Total in €',
		'For VAT-exempt revenue from sponsorship, the company must provide a consideration in the form of advertising or public relations. Describe here what consideration you will provide for each sponsorship received.':
			'For VAT-exempt revenue from sponsorship, the company must provide a consideration in the form of advertising or public relations. Describe here what consideration you will provide for each sponsorship received.',
		'Describe returns...': 'Describe returns...',
		'Material expenses were deleted': 'Material expenses were deleted',
		'Other expenses were deleted': 'Other expenses were deleted',
		'Expenses and input tax deduction was updated': 'Expenses and input tax deduction was updated',
		'Enter the total of your material and other expenses and the input tax (sales tax) included in them. The input tax is offset against the sales tax collected on your sales and reduces the tax payment.':
			'Enter the total of your material and other expenses and the input tax (sales tax) included in them. The input tax is offset against the sales tax collected on your sales and reduces the tax payment.',
		'Sales tax rate': 'Sales tax rate',
		'Material expenses in € incl. <%> VAT.': 'Material expenses in € incl. % VAT.',
		'% sales tax in €': '% sales tax in €',
		'Other expenses in € incl. <%> VAT.': 'Other expenses in € incl. % VAT.',
		'Other expenses not subject to sales tax': 'Other expenses not subject to sales tax',
		'Please enter an accurate list of VAT-exempt expenses here.':
			'Please enter an accurate list of VAT-exempt expenses here.',
		'Salary-related taxes was updated': 'Salary-related taxes was updated',
		'Total gross salaries (in €)': 'Total gross salaries (in €)',
		'minus 5% social security contribution (in €)': 'minus 5% social security contribution (in €)',
		'= Calculation basis (in €)': '= Calculation basis (in €)',
		'minus 10% wage tax (in €)': 'minus 10% wage tax (in €)',
		'= Net wages (in €)': '= Net wages (in €)',
		'Salary-related taxes (employer`s contribution)': 'Salary-related taxes (employer`s contribution)',
		'of which 6% social security contribution (in €)': 'of which 6% social security contribution (in €)',
		'Statement of revenues and expenses were updated': 'Statement of revenues and expenses were updated',
		'Statement of revenues': 'Statement of revenues',
		'Sales in € incl.': 'Sales in € incl.',
		'% VAT.': '% VAT.',
		'Total gross sales in €': 'Total gross sales in €',
		'Total sales tax': 'Total sales tax',
		'Turnover net total in €': 'Turnover net total in €',
		'Material expenses in € incl.': 'Material expenses in € incl.',
		'Other expenses in € incl.': 'Other expenses in € incl.',
		'Total gross costs in €': 'Total gross costs in €',
		'Input tax total in €': 'Input tax total in €',
		'Total net costs in €': 'Total net costs in €',
		'Advance return of the value added tax (UVA)': 'Advance return of the value added tax (UVA)',
		'Statement of expenses': 'Statement of expenses',
		'List of tasks': 'List of tasks',
		'Calculation half-year result was submitted': 'Calculation half-year result was submitted',
		'The semi-annual report was successfully submitted and cannot be changed now. Date':
			'The semi-annual report was successfully submitted on and cannot be changed now. Date',
		'Statement of income/expenses': 'Statement of income/expenses',
		'Sales net in €': 'Sales net in €',
		'less material and other costs net in €': 'less material and other costs net in €',
		'less personnel costs incl. all taxes in €': 'less personnel costs incl. all taxes in €',
		'less other expenses not subject to sales tax in €': 'less other expenses not subject to sales tax in €',
		'less junior insurance in €': 'less junior insurance in €',
		'Half-year result total in €': 'Half-year result total in €',
		'Calculation half-year expenses': 'Calculation half-year expenses',
		'Sales taxes collected in €': 'Sales taxes collected in €',
		'less input taxes in €': 'less input taxes in €',
		'Wage and salary contributions in €': 'Wage and salary contributions in €',
		'plus junior insurance in €': 'plus junior insurance in €',
		'Submit half-yearly financial statements': 'Submit half-yearly financial statements',
		'Payload or credit': 'Payload or credit',
		'Income/Expense statement ': 'Income/Expense statement ',
		'Calculation of contributions 2nd half': 'Calculation of contributions 2nd half',
		'Financial report second semester': 'Financial report second semester',
		'1st Semiannual Advance return of the value added tax (UVA)':
			'1st Semiannual Advance return of the value added tax (UVA)',
		'2nd Semiannual Advance return of the value added tax (UVA)':
			'2nd Semiannual Advance return of the value added tax (UVA)',
		'= Sales tax calculation': '= Sales tax calculation',
		'Income/Expense statement was updated': 'Income/Expense statement was updated',
		'Income/Expense statement for whole year': 'Income/Expense statement for whole year',
		'Total net income for the year in €': 'Total net income for the year in €',
		'thereof 10% corporate income tax in €': 'thereof 10% corporate income tax in €',
		'Payload or credit was updated': 'Payload or credit was updated',
		'Calculation of contributions 2nd half was submitted': 'Calculation of contributions 2nd half was submitted',
		'Calculated corporate income tax': 'Calculated corporate income tax',
		'Result VAT return in €': 'Result VAT return in €',
		'Total contributions in €': 'Total contributions in €',
		'Submit yearly financial statements': 'Submit yearly financial statements',
		'School deleted successfully': 'School deleted successfully',
		'No business plan yet': 'No business plan yet',
		'No risk analysis yet': 'No risk analysis yet',
		'Go To Students': 'Go To Students',
		'Privacy Statement': 'Privacy Statement',
		'Confirm email': 'Confirm email',
		'Need to confirm email': 'Need to confirm email',
		'Mr.': 'Mr.',
		'Ms.': 'Ms.',
		'Mrs.': 'Mrs.',
		Miss: 'Miss',
		Male: 'Male',
		Gender: 'Gender',
		Divers: 'Divers',
		Female: 'Female',
		Diverse: 'Diverse',
		Products: 'Products',
		Service: 'Service',
		'Services&Products': 'Services&Products',
		'Clothing & Accessories': 'Clothing & Accessories',
		'Office Supplies': 'Office Supplies',
		Electronics: 'Electronics',
		Vehicles: 'Vehicles',
		Vienna: 'Vienna',
		'Lower Austria': 'Lower Austria',
		Burgenland: 'Burgenland',
		Styria: 'Styria',
		'Upper Austria': 'Upper Austria',
		Salzburg: 'Salzburg',
		Tyrol: 'Tyrol',
		Vorarlberg: 'Vorarlberg',
		Carinthia: 'Carinthia',
		'Parental confirmation updated': 'Parental confirmation updated',
		'Managing director': 'Managing director',
		Procurement: 'Procurement',
		Finance: 'Finance',
		'Human Resources / Administration': 'Human Resources / Administration',
		'Marketing / Communication': 'Marketing / Communication',
		'Production / Services': 'Production / Services',
		Other: 'Other',
		'Technology / IT': 'Technology / IT',
		Sales: 'Sales',
		'Avatar successfully updated': 'Avatar successfully updated',
		'Avatar successfully deleted': 'Avatar successfully deleted',
		'Approve expert': 'Approve expert',
		'Disapprove expert': 'Disapprove expert',
		'The expert was rejected': 'The expert was rejected',
		'The expert is approved': 'Тhe expert is approved',
		'Not Activated': 'Not Activated',
		'In review': 'In review',
		'Social Media': 'Social Media',
		Reviewed: 'Reviewed',
		'Not Reviewed': 'Not Reviewed',
		'Document Type': 'Document Type',
		'Request sent successfully': 'Request sent successfully',
		'View profile': 'View profile',
		'Request to assign': 'Request to assign',
		'Company status': 'Company status',
		'Clear all': 'Clear all',
		'General Profit': 'General Profit',
		'Overdue Reports': 'Overdue Reports',
		'Search reports': 'Search reports...',
		'Clear All': 'Clear All',
		Approved: 'Approved',
		'Get certificate template': 'Get certificate template',
		'The file is too large. Current file size': 'The file is too large. Current file size',
		'Max file size is': 'Max file size is',
		'School Name': 'School Name',
		confirmEmail:
			'A confirmation email has been sent to <highlight>{{email}}</highlight>. Please click the confirmation link in this email to activate the account. Please also check your spam folder.',
		Number: 'Number',
		'Add Teacher': 'Add Teacher',
		'Risk analysis form successfully updated': 'Risk analysis form successfully updated',
		'Check Confirmed': 'Check Confirmed',
		Reject: 'Reject',
		'Reject Company': 'Reject Company',
		'Reject Parental Confirmation': 'Reject Parental Confirmation',
		'Download template': 'Download template',
		'Approve school': 'Approve school',
		'The school has been approved': 'The school has been approved',
		'Verify teacher': 'Verify teacher',

		// --- Merging teacher accounts --------------------------------------
		'Merge teachers': 'Merge teacher accounts',
		'Merge teachers?': 'Merge teacher accounts?',
		'Merge teacher': 'Merge with another teacher',
		mergeTeachersIntro:
			'If the same teacher has two accounts — after an email change, for instance — the two can be combined into one. One of the accounts is dissolved in the process.',
		'This account is dissolved': 'This account is dissolved',
		'This account remains': 'This account remains',
		'Supervised Junior Companies move along': 'Supervised Junior Companies move along',
		'Search teacher by name': 'Search teacher — first or last name',
		'Please choose the account that remains': 'Please choose the account that remains',
		'No school assigned': 'No school assigned',
		'Supervises no Junior Company': 'Supervises no Junior Company',
		supervisedCompaniesNote: 'Supervised Junior Companies ({{total}}):',
		'+ {{total}} more': '+ {{total}} more',
		mergeTeachersConfirmText:
			'"{{from}}" will be deleted for good. All supervised Junior Companies will belong to "{{to}}" afterwards.',
		mergeTeachersWarning:
			'The dissolved account is deleted for good — together with its login, its pending assignment requests and its notifications. This cannot be undone.',
		mergeTeachersDone: 'The accounts have been merged. "{{to}}" remains.',

		// --- Merging schools ----------------------------------------------
		'Merge schools': 'Merge schools',
		'Merge schools?': 'Merge schools?',
		'Merge school': 'Merge with another school',
		mergeSchoolsIntro:
			'If the same school was created twice, the two entries can be combined into one. One of them is dissolved in the process.',
		'This school is dissolved': 'This school is dissolved',
		'This school remains': 'This school remains',
		'Teachers, companies and students move along':
			'Teachers move along — together with their companies and students',
		'Search school by name, place or postal code': 'Search school — name, place or postal code',
		'Please choose the school that remains': 'Please choose the school that remains',
		'No teachers are assigned to this school.': 'No teacher is assigned to this school',
		'One teacher moves to the remaining school.': '1 teacher moves to the remaining school',
		teachersMoveNote: '{{count}} teachers move to the remaining school',
		mergeSchoolsConfirmText:
			'"{{from}}" will be deleted for good. All teachers assigned to it will belong to "{{to}}" afterwards.',
		mergeSchoolsWarning:
			'The dissolved school is deleted for good. This cannot be undone — it can only be created anew.',
		mergeSchoolsDone: 'The schools have been merged. "{{to}}" remains.',

		'Teacher status': 'Teacher status',
		Yes: 'Yes',
		No: 'No',
		'Need to upload parental confirmation': 'Please upload parental consent',
		'Need to upload parental confirmation or set Function & working area':
			'Need to upload parental confirmation or set Function & working area',
		'The shareholder was created successfully': 'The shareholder was created successfully',
		'Need review': 'Need review',
		'Analysis & Plan': 'Analysis & Plan',
		'Emp. / consent': 'Emp. / consent',
		'Employees and parental consent': 'Employees / of which with parental consent',
		'Parental consent': 'Parental consent',
		'Fed. State': 'Fed. State',
		'No main work area yet': 'No main work area yet',
		'School has been created successfully.': 'School has been created successfully.',
		'School has been updated successfully.': 'School has been updated successfully.',
		'Company profile has been updated successfully.': 'Company profile has been updated successfully.',
		'User profile has been updated.': 'User profile has been updated.',
		'Annual deadline': 'Annual deadline',
		'Semiannual deadline': 'Semiannual deadline',
		Deadline: 'Deadline',
		'The letter was sent successfully': 'The letter was sent successfully',
		'No need review': 'No need review',
		'Review status': 'Review status',
		Submitted: 'Submitted',
		Open: 'Open',
		Checked: 'Checked',
		'Company was created successful.': 'Company was created successful.',
		'Wait for an invitation from an existing company': 'Wait for an invitation from an existing company',
		'Company comment is updated': 'Company comment is updated',
		'Wait Invitation': 'Wait Invitation',
		'Not Verified': 'Not Verified',
		'not yet activated by the state administration': 'not yet activated by the state administration',
		'Email successfully changed': 'Email successfully changed',
		'Email change confirmation': 'Email change confirmation',
		Rejected: 'Rejected',
		'Parental confirmation was rejected, upload new please !':
			'Parental confirmation was rejected, upload new please !',
		'Status was updated': 'Status was updated',
		'Invoice created, you can find it in documents': 'Invoice created, you can find it in documents',
		'Change payment': 'Payment received',
		'Change pay': 'Change pay',
		'Company Reminders': 'Activation reminder',
		'1st reminder [x] days after company set-up started and not finished and no login':
			'1st reminder [x] days after company set-up started and not finished and no login',
		'1st reminder [x] days after company profile has been submitted for approval and no login':
			'1st reminder [x] days after company profile has been submitted for approval and no login',
		'Financial Reporting Reminders': 'Financial Reporting Reminders',
		'Junior Company': 'Junior Company',
		'1st reminder [x] days before deadline': '1st reminder [x] days before deadline',
		'Reminder frequency each [x] day(s)': 'Reminder frequency each [x] day(s)',
		'Junior Basic Company and Junior Compact Company': 'Junior Basic Company and Junior Compact Company',
		'Invoicing Reminders': 'Invoicing Reminders',
		'1st reminder [x] days after invoice has been issued': '1st reminderday [x] days after invoice has been issued',
		'Options was updated': 'Options was updated',
		days: 'Days',
		'Teacher Status': 'Teacher Status',
		'Number of Students': 'Number of Students',
		'Number of companies': 'Number of companies',
		details: 'Details',
		Administrator: 'Administrator',
		'Federal Administrator': 'Federal Administrator',
		'All states': 'All states',
		'Customize Widget': 'Customize Widget',
		VAT: 'VAT',
		'Debit note': 'Debit note',
		'Credit note': 'Credit note',
		Semiannual: 'Semiannual',
		Annual: 'Annual',
		Paid: 'Paid',
		'If the invoice amount matches the payment, the invoice status changes to paid. If there is a difference, the balance is not equal to zero.':
			'If the payment matches the invoice amount, the invoice switches to “Paid”. If there is a difference, an open balance remains.',

		// --- Record a payment ----------------------------------------------
		'Invoice amount': 'Invoice amount',
		'Already paid': 'Already paid',
		'Open balance': 'Open balance',
		'Amount received in €': 'Amount received in €',
		'Please enter an amount': 'Please enter an amount',
		'No more than the invoice amount': 'No more than the invoice amount',

		'Change status': 'Change status',
		'Widget settings updated successfully': 'Widget settings updated successfully',
		'The new password should differ from the old one': 'The new password should differ from the old one',
		'To be checked': 'To be checked',
		'Emp.': 'Emp.',
		'Pa.C': 'Pa.C',
		FS: 'FS',
		'Rep.': 'Rep.',
		'Bal.': 'Bal.',
		'Rev.': 'Rev.',
		'Exp.': 'Exp.',
		'Res.': 'Res.',
		'Cha.': 'Cha.',
		'Please wait': 'Please wait',
		'Wrong result': 'Wrong result',
		'Report was successfully submitted.': 'Report was successfully submitted.',
		Total: 'Total',
		Active: 'Active',
		Verification: 'Verification',
		Waitlist: 'Waitlist',
		'Add employee': 'Add Employee',
		'Employee status': 'Status',
		Invoice: 'Invoice',
		'Business plan': 'Business plan',
		'Parental confirmation': 'Parental confirmation',
		'Consent document': 'Consent document',
		'Participation document': 'Participation document',
		'Company certificate': 'Company certificate',
		'Shareholder certificate': 'Shareholder certificate',
		ANNUAL: 'ANNUAL',
		SEMIANNUAL: 'SEMIANNUAL',
		'Invoice payment reminder': 'Invoice payment reminder',
		'Assign Request': 'Assign Request',
		'The report has been submitted, the invoice was created. Please pay the invoice.':
			'The report has been submitted, the invoice was created. Please pay the invoice.',
		'Your request was accepted. Company': 'Your request was accepted. Company',
		'Your request was rejected. Company': 'Your request was rejected. Company',
		'wants to be assigned as teacher in your company.': 'wants to be assigned as teacher in your company.',
		'Company Confirmation': 'Company Confirmation',
		'has submitted company for business approval': 'has submitted company for business approval',
		'Congratulation!': 'Congratulation!',
		'Great Job, you have been awarded for participation in Junior Company Program - download your certificate':
			'Great Job, you have been awarded for participation in Junior Company Program - download your certificate',
		Payment: 'Payment',
		'You company has paid the invoice': 'You company has paid the invoice',
		'You company has to make a payment invoice': 'You company has to make a payment invoice',
		'New User': 'New User',
		'joined successfully to company !': 'joined successfully to company !',
		'Congratulation, you have successfully submitted the': 'Congratulation, you have successfully submitted the',
		'Fin. Report': 'Fin. Report',
		'Teacher Confirmation': 'Teacher Confirmation',
		'Congratulation, your account was confirmed by an admin':
			'Congratulation, your account was confirmed by an admin',
		'Congratulation, your parental confirmation has been approved by an admin':
			'Congratulation, your parental confirmation has been approved by an admin',
		'Congratulation, your company has been approved by an admin':
			'Congratulation, your company has been approved by an admin',
		'Report was rejected': 'Report was rejected',
		'Company report was rejected. Please check and submit report again.':
			'Company report was rejected. Please check and submit report again.',
		Employees: 'Employees',
		'Rep.Typ': 'Rep.Typ',
		Revenues: 'Revenues',
		Expanses: 'Expanses',
		Charges: 'Charges',
		Reported: 'Reported',
		'E-Mail': 'Email',
		'This report has been submitted and can no longer be edited. If something needs to be corrected, the administration can reset it.':
			'This report has been submitted and can no longer be edited. If something needs to be corrected, the administration can reset it.',
		'View Detail': 'View Detail',
		Branch: 'Branch',
		Jahresabschluss: 'Annual financial statement',
		'Deadline (d)': 'Deadline (d)',
		'Invoice Number': 'Invoice Number',
		Credit: 'Credit',
		Cancelled: 'Cancelled',
		'Cancel invoice': 'Cancel invoice',
		'Reason for cancellation': 'Reason for cancellation',
		'The invoice was cancelled': 'The invoice was cancelled',
		invoiceCancelHeading: 'Cancel invoice {{no}} for {{amount}}?',
		invoiceCancelExplain:
			'The invoice keeps its number but no longer counts towards the open items and is reported separately in the statistics. The report is reopened for editing — the figures entered stay in place. Submitting it again creates a new invoice with a new number. A payment already recorded stays with the cancelled invoice as a credit and is applied to the new invoice. Cancelling cannot be undone.',
		invoiceCancelCreditNote:
			'{{amount}} has already been paid on this invoice. The amount remains as a credit and is applied to the new invoice for this report the next time it is submitted.',
		'View Report': 'View Report',
		'Reject report': 'Reject report',
		'The report was reopened and the invoice cancelled': 'The report was reopened and the invoice was cancelled',
		reportRejectedWithCredit:
			'The report was reopened and the invoice was cancelled. {{amount}} remains as a credit and is applied to the new invoice.',
		'Not approved': 'Not approved',
		'Company Rejected': 'Company Rejected',
		'Submit Report': 'Submit Report',
		'Please submit report before deadline !': 'Please submit report before deadline !',
		'Edit Userprofile': 'Edit Userprofile',
		'Download parental consent': 'Download parental consent',
		'Download parental consent (not uploaded yet!)': 'Download parental consent (not uploaded yet!)',
		'Parental consent verfied': 'Parental consent verfied',
		'Parental consent (need verifying)': 'Parental consent (need verifying)',
		'New Employee': 'New Employee',
		'to work in the company.': 'to work in the company.',
		'New Teacher': 'New Teacher',
		'has invited the teacher': 'has invited the teacher',
		'to the enterprise.': 'to the enterprise.',
		'New Expert': 'New Expert',
		'as a economic experts.': 'as a economic experts.',
		'has registered': 'has registered',
		'Expert Confirmation': 'Expert Confirmation',
		'Great, you have dealt with the market and risk analysis.':
			'Great, you have dealt with the market and risk analysis.',
		'Your business plan has been successfully uploaded.': 'Your business plan has been successfully uploaded.',
		'has uploaded the parent/guardian consent form.': 'has uploaded the parent/guardian consent form.',
		'has submitted the company for verification and activation by JA Austria.':
			'has submitted the company for verification and activation by JA Austria.',
		'The parental/guardian consent form of': 'The parental/guardian consent form of',
		'has been verified and confirmed.': 'has been verified and confirmed.',
		'The declaration of consent of the parents or legal guardians of':
			'The declaration of consent of the parents or legal guardians of',
		'was rejected.': 'was rejected.',
		'Congratulations! Your company has been successfully verified by JA Austria. For the legitimation of your business, we have issued a company register extract':
			'Congratulations! Your company has been successfully verified by JA Austria. For the legitimation of your business, we have issued a company register extract',
		'must be uploaded up to a max. amount of': 'must be uploaded up to a max. amount of',
		'for you. For the sale of your company shares, the signed warrants':
			'for you. For the sale of your company shares, the signed warrants',
		'in the Share section.': 'in the Share section.',
		'Do not forget to prepare your financial report by': 'Do not forget to prepare your financial report by',
		'Your company has been reviewed by JA Austria and unfortunately could not be approved for business yet.':
			'Your company has been reviewed by JA Austria and unfortunately could not be approved for business yet.',
		'Congratulations, your financial report has arrived at JA Austria! On the basis of your data, a compilation of the levies has been prepared, which you can find in the "Documents" section. An open invoice':
			'Congratulations, your financial report has arrived at JA Austria! On the basis of your data, a compilation of the levies has been prepared, which you can find in the "Documents" section. An open invoice',
		'must be paid by bank transfer within': 'must be paid by bank transfer within',
		'days.': 'days.',
		'Attention. Your financial report has been put on hold after submission and needs to be resubmitted after revision.':
			'Attention. Your financial report has been put on hold after submission and needs to be resubmitted after revision.',
		Congratulations: 'Congratulations',
		'You have successfully completed the JA Austria programme. You can find your certificate in the "Documents" section':
			'You have successfully completed the JA Austria programme. Sie finden Ihr Teilnahmezertifikat im Bereich "Dokumente"',
		'Consent of parent or guardian': 'Consent of parent or guardian',
		'is a required field': 'is a required field',
		'is must be less than 10000 characters': 'is must be less than 10000 characters',
		'is must be greater than 200 characters': 'is must be greater than 200 characters',
		'Total fin. result': 'Total fin. result',
		'Wage and Salary contributions': 'Wage and Salary contributions',
		'Salary-dependent contributions (employee share)': 'Salary-dependent contributions (employee share)',
		'Salary-related contributions (employer`s contribution)':
			'Salary-related contributions (employer`s contribution)',
		'Show Reports': 'Show Reports',
		'Repeat password does not match with Password': 'repeat password does not match with Password',
		'Option warrant': 'Option warrant',
		'Course participation certificate': 'Course participation certificate',
		'Certificate of completion': 'Certificate of completion',
		'Welcome !': 'Welcome !',
		'Here you will find information about upcoming tasks around your company as well as hints about interesting offers and events of our partners.':
			'Here you will find information about upcoming tasks around your company as well as hints about interesting offers and events of our partners.',
		'Before your company starts business, it must be submitted to JA Austria for verification and activation. After activation you can offer your products, services and shares in your company on the market - for the legitimisation of these activities you will receive a company register extract and the template for issuing warrants.':
			'Before your company starts business, it must be submitted to JA Austria for verification and activation. After activation you can offer your products, services and shares in your company on the market - for the legitimisation of these activities you will receive a company register extract and the template for issuing warrants.',
		'The financial report provides you with information on the necessary taxes that are usually incurred in the course of business activities.':
			'The financial report provides you with information on the necessary taxes that are usually incurred in the course of business activities.',
		'Good luck for your company': 'Good luck for your company',
		Request: 'Request',
		'Open a modal window and confirm or reject the request.':
			'Open a modal window and confirm or reject the request.',
		'Further support teachers': 'Further support teachers',
		'Final Report uploaded successfully': 'Final Report uploaded successfully',
		'Business Plan uploaded successfully': 'Business Plan uploaded successfully',
		'Business Plan removed successfully': 'Business Plan removed successfully',
		'Please log out and wait until you are invited by a member of an existing company. After being invited and logging in again, you will be immediately assigned to your joint company as an employee.':
			'Please log out and wait until you are invited by a member of an existing company. After being invited and logging in again, you will be immediately assigned to your joint company as an employee.',
		"Don't forget to submit your company for approval (button in dashboard area)":
			"Don't forget to submit your company for approval (button in dashboard area)",
		'days!': 'days!',
		'Company activation page.': 'Company activation page.',
		Reminder: 'Reminder',
		'Business Report': 'Business Report',
		'Your business report has been successfully uploaded.': 'Your business report has been successfully uploaded.',
		'Download Final Report': 'Download Final Report',
		'Download Business Plan': 'Download Business Plan',
		'Shareholder Share for Junior': 'Shareholder Share for Junior',
		'Shareholder Share for Junior Compact': 'Shareholder Share for Junior Compact',
		'Shareholder Share for Junior Basic': 'Shareholder Share for Junior Basic',
		'Junior Annual report deadline': 'Junior Annual report deadline',
		'Junior Semiannual report deadline': 'Junior Semiannual report deadline',
		'Junior Compact report deadline': 'Junior Compact report deadline',
		'Junior Basic report deadline': 'Junior Basic report deadline',
		'Anonimize and clear db': 'Anonimize and clear db',
		'The open invoice from for was paid incompletely. Your company account has a balance of. Please transfer the difference to the account details provided.':
			'The open invoice from {{val1}} for {{val2}} was paid incompletely. Your company account has a balance of {{val3}}. Please transfer the difference to the account details provided.',
		'New employee invited': 'New employee invited',
		'has invited to work in the company.': '{{val1}} has invited {{val2}} to work in the company.',
		'has invited the teacher to the enterprise.': '{{val1}} has invited {{val2}} the teacher to the enterprise.',
		'Teacher invited': 'Teacher invited',
		'has registered as a company expert.': '{{val1}} has registered {{val2}} as a company expert.',
		'Economic expert added': 'Economic expert added',
		'Business expert agrees with the GDPR.': 'Business expert {{val1}} agrees with the GDPR.',
		'Economic expert confirmed': 'Economic expert confirmed',
		'Market- & Riskanalysis': 'Market- & Riskanalysis',
		'Parent/guardian consent': 'Parent/guardian consent',
		'Company under verfication': 'Company under verfication',
		'The parental/guardian consent form of has been verified and confirmed.':
			'The parental/guardian consent form of {{val1}} has been verified and confirmed.',
		'Consent confirmed': 'Consent confirmed',
		'Consent rejected': 'Consent rejected',
		'The declaration of consent of the parents or legal guardians of was rejected.':
			'The declaration of consent of the parents or legal guardians of {{val1}} was rejected.',
		'has uploaded the course certificate.': 'has uploaded the course certificate.',
		'Course certificate confirmed': 'Course certificate confirmed',
		'The course certificate of has been verified and confirmed.':
			'The course certificate of {{val1}} has been verified and confirmed.',
		'Course certificate rejected': 'Course certificate rejected',
		'The course certificate of was rejected.': 'The course certificate of {{val1}} was rejected.',
		'Company verified': 'Company verified',
		'Company not approved': 'Company not approved',
		'Financial report reminder': 'Financial report reminder',
		'Financial report rejected': 'Financial report rejected',
		'The open invoice from for has been paid.': 'The open invoice from {{val1}} for {{val2}} has been paid.',
		'Participation certificate': 'Participation certificate',
		'Invoice amount paid incompletely': 'Invoice amount paid incompletely',
		'Invoice generated': 'Invoice generated',
		'Here you will find information about activities of the companies you support as well as information about interesting offers and events of our partners.':
			'Here you will find information about activities of the companies you support as well as information about interesting offers and events of our partners.',
		'The JA Austria company has added you as a supervising teacher. You can now follow the details of the assigned companies in the "Companies" section and also have access to their documents such as business plan, shareholder certificates, financial reports and annual report.':
			'The JA Austria company {{val1}} has added you as a supervising teacher. You can now follow the details of the assigned companies in the "Companies" section and also have access to their documents such as business plan, shareholder certificates, financial reports and annual report.',
		'New company': 'New company',
		'Report submitted': 'Report submitted',
		'Your report has been submitted successfully':
			'Your {{val1}} has been submitted successfully and can no longer be changed.',
		'The company you supervise has filed. You can find the report here':
			'The company you supervise {{val1}} has {{val2}} filed. You can find the report here',
		'Congratulations! Your company has submitted its financial report and thus successfully completed the JA Austria Programme. For the students involved in the company we have deposited completion certificates in the "Documents" section - the students can download them independently. You can find the business report here ':
			'Congratulations! Your company {{val1}} has submitted its financial report and thus successfully completed the JA Austria Programme. For the students involved in the company we have deposited completion certificates in the "Documents" section - the students can download them independently. You can find the business report here ',
		'We would also like to thank you very much for your support of the JA Austria programme with a certificate':
			'We would also like to thank you very much for your support of the JA Austria programme with a certificate',
		'Financial report submitted & certificates have been issued':
			'Financial report submitted & certificates have been issued',
		'Attention the following JA Austria companies you are in charge of have not yet submitted their report in our system and therefore cannot successfully complete the programme. Company: ':
			'Attention the following JA Austria companies you are in charge of have not yet submitted their report in our system and therefore cannot successfully complete the programme. Company: ',
		'Congratulations! The company you are in charge of has been checked by JA Austria and activated for further business activities. The students have received an extract from the company register and can now sell shares in the company up to a total value of EUR . The following date(s) have been set for report submission':
			'Congratulations! The company you are in charge of {{val1}} has been checked by JA Austria and activated for further business activities. The students have received an extract from the company register and can now sell shares in the company up to a total value of EUR {{val2}} . The following date(s) have been set for report submission',
		'Invoice paid': 'Invoice paid',
		Branches: 'Branches',
		Planned: 'Planned',
		Draft: 'Draft',
		'Set to draft': 'Set to draft',
		'Activate message': 'Activate',
		'The message is now active.': 'The message is now active.',
		'The message was set to draft.': 'The message was set to draft.',
		'Pin message': 'Pin to top',
		'Unpin message': 'Unpin',
		'Pinned to top': 'Pinned to top',
		Pinned: 'pinned',
		'Not pinned': 'not pinned',
		'The message is now pinned to the top.': 'The message is now pinned to the top.',
		'The message is no longer pinned.': 'The message is no longer pinned.',
		'Active — visible during the display period': 'Active — visible during the display period',
		'Draft — visible to the administration only': 'Draft — visible to the administration only',
		'Draft or active? A draft stays hidden from students and teachers until it is activated.':
			'Draft or active? A draft stays hidden from students and teachers until it is activated.',
		'Delete employee': 'Delete employee',
		'to your company in the company profile section.': 'to your company in the company profile section.',
		'Ready for submission': 'Ready for submission',
		'Congratulations you have everything complete. Your company can now be submitted to JA Austria for review.':
			'Congratulations you have everything complete. Your company can now be submitted to JA Austria for review.',
		'Final Report': 'Final Report',
		'Please upload your final report via the upload function in the dashboard. Afterwards you will find your participation certificates for the successful completion of the JA Austria programme in the document section.':
			'Please upload your final report via the upload function in the dashboard. Afterwards you will find your participation certificates for the successful completion of the JA Austria programme in the document section.',
		'Open profile': 'Open profile',
		'You have new news - click to look details': 'You have new news - click to look details',
		and: 'and',
		others: 'others',
		'This field must be over 0': 'This field must be over 0',
		Delete: 'Delete',
		'Delete the company': 'Delete the company',
		'The company successfully deleted': 'The company successfully deleted',
		'Upload logo & product images': 'Upload logo & product images',
		'Function & working area': 'Function & working area',
		'The company must not be leaderless!': 'The company must not be leaderless!',
		'First assign your CEO function to another person!': 'First assign your CEO function to another person!',
		'CEO / Managing Director': 'CEO / Managing Director',
		'Add link': 'Add link',
		'CEO role can be transferred in the view "Employees" via the 3-point menu':
			'CEO role can be transferred in the view "Employees" via the 3-point menu',
		'Edit function & working area': 'Edit function & working area',
		public: 'public',
		private: 'private',
		Explanation: 'Explanation',
		'Not verified': 'Not verified',
		Show: 'Show',
		'Wait for confirmation new employee': 'Wait for confirmation new employee',
		'Switch to student view': 'Switch to student view',
		years: 'years',
		'A working area has to be selected. Please assign for a working area':
			'A working area has to be selected. Please assign for a working area',
		'This icon shows incomplete steps, such as missing parental confirmation, unassigned working area, or pending employee invitation.':
			'This icon shows incomplete steps, such as missing parental confirmation, unassigned working area, or pending employee invitation.',
		'Gross salaries may not be EUR 0 in both semesters': 'Gross salaries may not be EUR 0 in both semesters',
		'Remove employee.': 'Remove employee.',
		'No working area': 'No working area',
		'The company must consist of at least two employees': 'The company must consist of at least two employees',
		"You are currently in a student's view": " You are currently in a student's view",
		// Admin view mode as a teacher (02.11.2026) and the explanation lines
		// in the "Actions" tab of the user profile.
		'view mode as Student': 'View as student',
		'view mode as Teacher': 'View as teacher',
		viewModeBannerTeacher: 'You are currently viewing the platform as teacher {{name}} – read only',
		'Exit view mode': 'Exit view',
		'Mark parental consent as reviewed': 'Mark parental consent as reviewed',
		actionHintViewMode: 'See the platform the way this person sees it – read only, nothing is changed.',
		actionHintDownloadParental: 'Save the uploaded document as a file.',
		actionHintParentalMissing: 'Not uploaded yet.',
		actionHintReviewParental: 'Confirm after reviewing – only then does it count in the checklist.',
		actionHintParentalReviewed: 'Already reviewed and confirmed.',
		actionHintMergeTeacher: 'Resolve a duplicate: this account is merged into another one, supervised Junior Companies move along.',
		actionHintVerifyTeacher: 'Confirm this account as a genuine teacher.',
		actionHintTeacherVerified: 'Already verified.',
		actionHintDeleteAccount: 'Permanent – cannot be undone.',
		'Test environment': 'Test environment',
		'Collective mailbox (MailHog)': 'Collective mailbox (MailHog)',
		'This platform does not use cookies or tracking services. Only technically necessary data (login, language selection) is stored locally in your browser.':
			'This platform does not use cookies or tracking services. Only technically necessary data (login, language selection) is stored locally in your browser.',
		'Privacy notice': 'Privacy notice',
		'Got it': 'Got it',
		'Required field': 'Required field',
		'Invalid email': 'Invalid email',
		Done: 'Done',
		inviteExpertSentTo: 'The invitation to {{name}} ({{email}}) has been sent.',
		expertInviteResent: 'Invitation sent again',
		inviteExpertAlreadyInvited:
			'You already invited {{name}} on {{date}}, and the invitation has not been accepted yet. We have sent it again with a new link — the old link no longer works.',
		pendingInvitationsTitle: 'Open invitations',
		pendingInvitationsHint:
			'You invited these people; they have not accepted yet. As soon as they activate their profile, they appear under "Our experts".',
		pendingInvitationSent: 'invited on {{date}}',
		pendingInvitationSentBy: 'invited on {{date}} by {{name}}',
		pendingInvitationValidUntil: 'Link valid until {{date}}',
		pendingInvitationExpired: 'Link expired – please send again',
		pendingInvitationResend: 'Send again',
		pendingInvitationResent: 'The invitation to {{name}} has been sent again.',
		pendingInvitationWithdraw: 'Withdraw',
		pendingInvitationWithdrawTitle: 'Withdraw invitation?',
		pendingInvitationWithdrawText:
			'The invitation to {{name}} ({{email}}) will be deleted. The link in the email that was sent will no longer work.',
		pendingInvitationWithdrawn: 'The invitation has been withdrawn.',
		inviteExpertNotSent:
			'The invitation to {{name}} has been created, but the email could not be sent. Please pass on the link yourself.',
		inviteShareTitle: 'Pass on the invitation link yourself',
		inviteShareHint:
			'The invitation comes from Junior Achievement and sometimes ends up in spam. Send the link yourself as well – from your own address or a messenger it arrives reliably.',
		inviteShareCopy: 'Copy link',
		inviteShareCopied: 'Copied',
		inviteShareMail: 'Open in my email program',
		inviteShareSubject: 'Invitation: supporter at Junior Achievement',
		inviteShareSubjectCompany: 'Invitation from the Junior Company “{{company}}”',
		inviteShareGreeting: 'Hello {{name}},',
		inviteShareGreetingPlain: 'Hello,',
		inviteShareBody: 'as discussed, here is the link to create your supporter profile at Junior Achievement:',
		inviteShareBodyCompany:
			'our Junior Company “{{company}}” would be glad if you supported us as a business expert. Use this link to create your profile:',
		inviteShareBodyValidity:
			'The link is valid for {{days}} days. An email from Junior Achievement with the same link is on its way too – if you cannot find it, please check your spam folder.',
		inviteShareClosing: 'Best regards\n{{name}}',
		inviteShareClosingPlain: 'Best regards',
		invitedOnColumn: 'Invited on',
		invitationExpiredShort: 'expired',
		invitationDayLeft: '{{count}} day left',
		invitationDaysLeft: '{{count}} days left',
		invitationRemindedTimes: 'reminded {{count}}×',
		invitationReminders: 'Reminders',
		invitationRemindersNone: 'none yet',
		invitationRemindersCount: '{{count}}×, last on {{date}}',
		supporterInvitationExpired:
			'This invitation has expired. Please contact the person who invited you or Junior Achievement: the invitation can be sent again at any time.',
		'This invitation link is invalid or has already been used':
			'This invitation link is invalid or has already been used',
		Imprint: 'Imprint',
		'Privacy policy': 'Privacy policy',
		'Terms of use': 'Terms of use',
		Accessibility: 'Accessibility',
		'Legal information': 'Legal information',
		'Back to home page': 'Back to home page',
		'The Junior Companies of Junior Achievement Austria': 'The Junior Companies of Junior Achievement Austria',
		'Website & Social Media': 'Website & Social Media',
		'Please note the URL syntax e.g. https://www.junior.cc':
			'Please note the URL syntax e.g. https://www.junior.cc',
		'The invitation to join the company has been revoked. Begin your registration in the system without the invitation link to create your own company.':
			'The invitation to join the company has been revoked. Begin your registration in the system without the invitation link to create your own company.',
		Export: 'Export',
		'Download report': 'Download report',
		'Total charges in €': 'Total charges in €',
		'We have created an': 'We have created an',
		'based on your report. Please pay it by': 'based on your report. Please pay it by',
		'based on your report.': 'based on your report.',
		'You can find the invoice in the': 'You can find the invoice in the',
		'The financial report is overdue by one day.': 'The financial report is one day overdue.',
		'The financial report is overdue by several days.': 'The financial report is {{days}} days overdue.',
		'The financial report is due tomorrow.': 'The financial report is due tomorrow.',
		'The financial report is due in several days.': 'The financial report is due in {{days}} days.',
		'The financial report is due today.': 'The financial report is due today.',
		'Please do not forget to submit your financial report.':
			'Please do not forget to submit your financial report.',
		'Half-year report': 'Half-year report',
		'annual report': 'annual report',
		'Create message': 'Create message',
		Content: 'Content',
		Stateadmin: 'State admin',
		Federaladmin: 'Federal admin',
		'Manage State Admins': 'Manage state admins',
		'Manage Federal Admins': 'Manage federal admins',
		'Manage Database Reset': 'Manage database reset',
		'Admin roles': 'Role',
		'Select admin role': 'Select role',
		'State admin for one federal state, federal admin Austria-wide.':
			'State admin for one federal state, federal admin Austria-wide.',
		'Edit administrator': 'Edit administrator',
		'Role and additional functions': 'Role and additional functions',
		Person: 'Person',
		'Role and rights': 'Role and rights',
		Responsibility: 'Responsibility',
		'A state admin looks after one federal state and sees only its data.':
			'A state admin looks after one federal state and sees only its data.',
		'A federal admin works Austria-wide and can additionally be given the functions below.':
			'A federal admin works Austria-wide and can additionally be given the functions below.',
		'Responsible Austria-wide — no federal state.': 'Responsible Austria-wide — no federal state.',
		'Additional functions only exist for federal admins. Without a tick the person sees the administration, but changes nothing there.':
			'Additional functions only exist for federal admins. Without a tick the person sees the administration, but changes nothing there.',
		'May create, edit and delete state admins.': 'May create, edit and delete state admins.',
		'May create, edit and delete federal admins — and may choose the role when creating an administrator.':
			'May create, edit and delete federal admins — and may choose the role when creating an administrator.',
		'Unlocks the school year reset under Settings › System: the data is exported and cleared. Teachers, administrators, supporters, school master data and all settings are kept.':
			'Unlocks the school year reset under Settings › System: the data is exported and cleared. Teachers, administrators, supporters, school master data and all settings are kept.',
		'Administrators at a glance': 'Administrators at a glance',
		'By role': 'By role',
		'By state': 'By federal state',
		'Without federal state': 'Without federal state',
		'Last sign-in': 'Last sign-in',
		'Signed in within {{days}} days': 'Signed in within {{days}} days',
		'Last sign-in has been recorded since 06.08.2026 — earlier sign-ins are unknown.':
			'Last sign-in has been recorded since 06.08.2026 — earlier sign-ins are unknown.',
		'Filter the list by {{label}}': 'Filter the list by {{label}}',
		'Filtered by': 'Filtered by',
		'Remove the filter {{label}}': 'Remove the filter {{label}}',
		'{{shown}} of {{all}} administrators': '{{shown}} of {{all}} administrators',
		'No administrator matches this filter.': 'No administrator matches this filter.',
		'Accounts without a sign-in since then: {{amount}}': 'Accounts without a sign-in since then: {{amount}}',
		ADMINISTRATOR: 'State admin',
		FEDERAL_ADMINISTRATOR: 'Federal admin',
		Verify_company_email_btn: 'Verify email',
		Verify_company_email_sending_successfully: 'Verify email',
		Verify_company_email_sent_to:
			'Verification email sent to {{email}}. Please also check the spam folder – the link is valid for one hour.',
		"This icon means that the company's email verification has not yet been completed.":
			"This icon means that the company's email verification has not yet been completed.",
		// Page behind the button in the confirmation email (pages/CompanyEmailVerifyPage)
		'Confirming email address …': 'Confirming email address …',
		'Email address confirmed': 'Email address confirmed',
		'Email address could not be confirmed': 'Email address could not be confirmed',
		'The company email address is now confirmed. This is one of the requirements for submitting your company for approval.':
			'The company email address is now confirmed. This is one of the requirements for submitting your company for approval.',
		'This email address was already confirmed. Nothing else to do.':
			'This email address was already confirmed. Nothing else to do.',
		'The company email address has been confirmed.': 'The company email address has been confirmed.',
		'You will be forwarded in a moment …': 'You will be forwarded in a moment …',
		'To the dashboard': 'To the dashboard',
		'The confirmation link is incomplete. Please open it again from the email.':
			'The confirmation link is incomplete. Please open it again from the email.',
		'This confirmation link has expired or is invalid. A new confirmation email can be requested in the company profile.':
			'This confirmation link has expired or is invalid. A new confirmation email can be requested in the company profile.',
		'There is no Junior Company for this email address. Has the address been changed in the meantime?':
			'There is no Junior Company for this email address. Has the address been changed in the meantime?',
		'The email address could not be confirmed. Please try again later.':
			'The email address could not be confirmed. Please try again later.',
		verifyingCompany: 'Verifying Company Email',
		'Update Email': 'Update Email',
		'Mail successfully changed': 'Mail successfully changed',
		'No company with such an old email was found': 'No company with such an old email was found',
		day: 'Day',
		month: 'Month',
		year: 'Year',
		dd: 'DD',
		mm: 'MM',
		yyyy: 'YYYY',
		'Name successfully changed': 'Company Name successfully changed',
		'No company with such an old name was found': 'No company with such an old name was found',
		'Verify your company email address': 'Verify your company email address',
		'Checklist for approval': 'Checklist for approval',
		'Company profile & risk analysis completed': 'Company profile & risk analysis completed',
		'Minimum of 2 employees in the team': 'Minimum of 2 employees in the team',
		'Min. 1 business expert assigned': 'Min. 1 business expert assigned',
		'Parental/guardian consent form uploaded and checked': 'Parental/guardian consent form uploaded and checked',
		'No employees remaining on the waiting list': 'No employees remaining on the waiting list',
		'A function assigned to all employees': 'A function assigned to all employees',
		'Company email address verified': 'Company email address verified',
		'The company profile and risk analysis must be fully completed':
			'The company profile and risk analysis must be fully completed',
		'Your company requires a minimum of two registered student employees':
			'Your company requires a minimum of two registered student employees',
		'An external business expert must be assigned to your team':
			'An external business expert must be assigned to your team',
		'All signed parental consent forms must be available': 'All signed parental consent forms must be available',
		'The official email address of your student company must be confirmed':
			'The official email address of your student company must be confirmed',
		'Working area assigned': 'Working area assigned',
		'Submit for approval': 'Submit for approval',
		'Delete invitation': 'Delete invitation',
		'Resend invitation': 'Resend invitation',
		'Invitation resent successfully': 'Invitation resent successfully',
		'Add work area': 'Add work area',
		'Managing Director updated': 'Managing Director updated',
		'Saved successfully': 'Saved successfully',
		'Reason for rejecting the parental confirmation': 'Reason for rejecting the parental confirmation',
		'Reason for rejecting the course certificate': 'Reason for rejecting the course certificate',
		'The course certificate was rejected successfully': 'The course certificate was rejected successfully',
		Elternbestätigung: 'Parental confirmation',
		Kursnachweis: 'Course certificate',
		'Send to student': 'Send to student',
		'Reason for rejection to the entire team': 'Reason for rejection to the entire team',
		'Send to the team': 'Send to the team',
		Next_SignUp: 'Next',
		'Back to registration': 'Back to registration',
		Login: 'Login',
		Expired: 'Expired',
		'Valid for {{days}} more days': 'Valid for {{days}} more days',

		/* Error messages — shown when the server says nothing usable, see shared/errorMessage.js. */
		'Something went wrong. Please try again.': 'Something went wrong. Please try again.',
		'No connection to the server. Please check your internet connection and try again.':
			'No connection to the server. Please check your internet connection and try again.',
		'The server did not respond in time. Please try again.':
			'The server did not respond in time. Please try again.',
		'Please check your entries and try again.': 'Please check your entries and try again.',
		'Your session has expired. Please sign in again.': 'Your session has expired. Please sign in again.',
		'You do not have permission to do this.': 'You do not have permission to do this.',
		'This entry no longer exists. It may have been deleted in the meantime.':
			'This entry no longer exists. It may have been deleted in the meantime.',
		'This does not work because there is already an entry for it.':
			'This does not work because there is already an entry for it.',
		'The file is too large.': 'The file is too large.',
		'This file format is not supported.': 'This file format is not supported.',
		'Too many requests in a short time. Please wait a moment and try again.':
			'Too many requests in a short time. Please wait a moment and try again.',
		'Something went wrong on the server. Please try again later.':
			'Something went wrong on the server. Please try again later.',
		'The server cannot be reached at the moment. Please try again in a few minutes.':
			'The server cannot be reached at the moment. Please try again in a few minutes.',
		'Basic Information': 'Basic information',
		'Contact Details': 'Contact details',
		'Registration date': 'Registration date',
		'Submitted for review on': 'Submitted on',
		Logo: 'Logo',
		'No logo yet': 'No logo yet',
		Website: 'Website',
		Status: 'Status',
		'Company status active': 'Activated',
		'Company status in review': 'Submitted for review',
		'Company status not activated': 'Not activated yet',
		'Connected experts': 'Connected supporters',
		'Connected experts hint':
			'Requests by this junior company that were accepted or are still open. Students send the requests.',
		'Matching supporters': 'Matching supporters',
		'Matching experts hint':
			'Who matches this junior company by target group (state, industry, school type) and is open to new requests.',
		'Own economic experts': 'Economic experts entered by the company',
		'Own economic experts hint':
			'Legacy entries made by the junior company itself; new entries are no longer possible. Connected supporters below also count towards activation.',
		'Two expert registers':
			'Two separate registers: above are the economic experts the junior company entered itself — standalone entries without a profile in the supporters module. Below are the supporters from the Junior Achievement directory this junior company is connected to. The two counts are therefore independent of each other.',
		'No connected experts yet': 'This junior company has not requested a supporter yet.',
		'Experts could not be loaded': 'The experts could not be loaded.',
		'More in the supporters module': '{{rest}} more are listed under',
		Complete: 'Complete',
		Incomplete: 'Incomplete',
		'Still open': 'Still open',
		'An activated company needs at least one business expert.':
			'An activated company needs at least one business expert.',
		'This person is not part of your company.': 'This person is not part of your company.',
		'The company profile could not be loaded.': 'The company profile could not be loaded.',
		'Try again': 'Try again',
		'The risk analysis could not be loaded.': 'The risk analysis could not be loaded.',
		Invite: 'Invite',
		List: 'List',
		Tiles: 'Tiles',
		View: 'View',
		'Teacher invite hint':
			'Teachers can be assigned via the person search or invited by email. Employees and economic experts are still added by the company itself.',
		'Market and risk analysis hint': 'The market and risk analysis opens in a separate window.',
		'No employees yet': 'No employees yet',
		'No economic experts yet': 'No economic experts yet',
		'No company certificate yet': 'No company certificate yet',
		'Company certificate is created on activation':
			'The company certificate is created when the company is activated.',
		'Final report': 'Final report',
		'No final report yet': 'No final report yet',
		'Final report becomes relevant after activation':
			'The final report is only needed once the company has been activated.',
		'Final report uploaded successfully': 'Final report uploaded successfully',
		'Open document': 'Open',
		Replace: 'Replace',
		Upload: 'Upload',
		'New entry': 'New entry',
		'Comment on this company': 'Comment on this company',
		'Also send to': 'Also send to',
		Delivery: 'Delivery',
		'Internal message': 'Internal message',
		'Comment stays internal': 'Stays visible to the administration only.',
		'Pick at least one channel': 'Please pick at least one channel.',
		'Entry saved': 'Entry saved',
		'No entries yet': 'No entries yet',
		Comment: 'Comment',
		'Internal only': 'Internal only',
		'Company submitted for review': 'Company submitted for review',
		'Company activated': 'Company activated',
		'Company rejected': 'Company not approved',
		'Company certificate created': 'Company certificate created',
		'Company certificate regenerated': 'Company certificate regenerated',
		'Business plan uploaded': 'Business plan uploaded',
		'Final report uploaded': 'Final report uploaded',
		Comments: 'Comments',
		Actions: 'Actions',
		'Change history': 'Change history',
		'Type a comment': 'Type a comment',
		'Comments stay internal': 'Comments stay visible to the administration only.',
		'Comments are available once the record is saved': 'Comments become available once the record is saved.',
		'School created': 'School created',
		'School approved': 'School approved',
		'Master data changed': 'Master data changed',
		'School merged in': 'School merged in',
		'Profile changed': 'Profile changed',
		'Account merged in': 'Account merged in',
		'Parental confirmation reviewed': 'Parental confirmation reviewed',
		'Parental confirmation rejected': 'Parental confirmation rejected',
		'Course certificate reviewed': 'Course certificate reviewed',
		'Invoice created': 'Invoice created',
		'Partial payment recorded': 'Partial payment recorded',
		'Payment reminder sent': 'Payment reminder sent',
		'Invoice cancelled': 'Invoice cancelled',
		'Report returned': 'Report returned',
		'Expert added': 'Expert added',
		'Details changed': 'Details changed',
		'Expert confirmed': 'Expert confirmed',
		'Expert confirmation withdrawn': 'Expert confirmation withdrawn',
		'Request sent': 'Request sent',
		'Request accepted': 'Request accepted',
		'Request declined': 'Request declined',
		'Request expired without an answer': 'Request expired without an answer',
		'Collaboration ended by the Junior Company': 'Collaboration ended by the Junior Company',
		'Collaboration ended by the expert': 'Collaboration ended by the expert',
		'Semiannual report submitted': 'Semiannual report submitted',
		'Annual report submitted': 'Annual report submitted',
		'Semiannual report returned': 'Semiannual report returned',
		'Annual report returned': 'Annual report returned',
		'Company name changed': 'Company name changed',
		'Company email changed': 'Company email changed',
		'Message from the administration': 'Message from the administration',
		'Message from the administration about {{val1}}': 'Message from the administration about {{val1}}',
		'Document reviewed': 'Reviewed',
		'Not reviewed yet': 'Not reviewed yet',
		'Open message history': 'Open message history',
		'Messages from the administration': 'Messages from the administration',
		'Messages from the administration about {{val1}}': 'Messages from the administration about {{val1}}',
		'No messages yet': 'No messages yet',
		'Update Name': 'Update name',
		'Company Name successfully changed': 'Company name changed successfully',
		'REGENERATED COMPANY CERTIFICATE': 'Company certificate regenerated',
		'zu prüfen': 'to review',
		'Comment on the activation (optional)': 'Comment on the activation (optional)',
		'No sales forecast yet': 'No sales forecast yet',
		'No risks recorded yet': 'No risks recorded yet',
		'Estimated annual sales, total': 'Estimated annual sales, total',
		'School and teachers': 'School & teachers',
		location: 'Address',
		'How a company gets an expert': 'How a company gets an economic expert',
		'Quick guide': 'Quick guide',
		'Expert flow badge': 'No assignment possible',
		'Expert flow route one': 'Route 1 · Asking an existing expert',
		'Expert flow new people': 'Route 2 · Inviting new people',
		'Expert step request title': 'Request',
		'Expert step notified title': 'Notification',
		'Expert step decision title': 'Decision',
		'Expert step connected title': 'Connected',
		'Expert connection intro':
			'Administration cannot assign anyone here. A connection is only created when the company itself asks and the expert accepts.',
		'Expert step request':
			'A student or teacher opens an expert profile and chooses „Request expert" — an accompanying message is possible.',
		'Expert step notified': 'The request appears for the expert under „My connections"; an email goes out as well.',
		'Expert step decision': 'The expert accepts or declines. Both sides are informed by email.',
		'Expert step connected':
			'Contact details only become visible to the company once the status is „Connected". Either side can end the collaboration at any time.',
		'Expert invite anyone':
			'Students and teachers invite experts themselves — usually acquaintances or family, without approval by Junior Achievement. The invited person is at first only visible to this Junior Company. Administration creates new profiles under',
		Available: 'available',
		Missing: 'missing',
		'Company certificate renewed': 'Company certificate renewed',
		'Company certificate renewed details':
			'The company name was changed. Because the company is active, the company certificate was regenerated right away — you will find it in the <b>Documents</b> tab.<br><br>The previous certificate is no longer valid and should not be used any more.',
		Understood: 'Understood',
		'Company profile': 'Company profile',
		'Not available': 'Not available',
		'Something went wrong': 'Something went wrong',

		// Lists and preview
		School: 'School',
		'read more': 'read more',
		Download: 'Download',
		'Previous file': 'Previous file',
		'Next file': 'Next file',
		'Use the arrow keys to page through.': 'Use the arrow keys to page through.',
		'The file could not be opened.': 'The file could not be opened.',
		'This file type cannot be shown here.': 'This file type cannot be shown here.',
		'Confirmation pending': 'Confirmation pending',
		'Teacher activated': 'Teacher activated',
		'Only companies without reports can be deleted.':
			'Only companies without reports and without activation can be deleted.',
		'Rejection is only possible until the first report.':
			'Rejection is only possible until the first submitted report. After that, invoice, shares and report depend on this company.',

		// Rueckfrage vor dem Verwerfen (UI/ConfirmDialog)
		'Discard unsaved changes?': 'Discard unsaved changes?',
		'This window contains changes that have not been saved yet.':
			'This window contains changes that have not been saved yet.',
		'Discard changes': 'Discard changes',
		'Continue editing': 'Continue editing',

		// Dashboard: what to do next (views/common/CompanySteps)
		'Checklist up to activation': 'Checklist up to activation',
		'Checklist up to the certificate': 'Checklist up to the certificate',
		// Progress bar (UI/CompanyProgress)
		'Company progress': 'Company progress',
		'Current step': 'Up next',
		'All steps done': 'All steps done',
		// Progress bar and checklist point at each other (shared/companyStepLink)
		'Show the matching item in the checklist': 'Highlight the matching item in the checklist',
		'Show the matching step in the progress bar': 'Highlight the matching step in the progress bar',
		done: 'done',
		Add: 'Add',
		'Go there': 'Go there',
		'Open link': 'Open link',
		'overdue by {{days}} days': 'overdue by {{days}} days',
		'Optional — you can upload the business plan of your Junior Company here.':
			'Optional — you can upload the business plan of your Junior Company here.',
		'Sell shares': 'Sell shares',
		'Issue share certificates to your shareholders.': 'Issue share certificates to your shareholders.',
		'Financial Report': 'Financial report',
		'Fill in the report and submit it.': 'Fill in the report and submit it.',
		'The invoice is in your documents as soon as the report has been submitted.':
			'The invoice is in your documents as soon as the report has been submitted.',
		'Upload your business report.': 'Upload your business report.',
		'Possible as soon as the financial reports have been submitted.':
			'Possible as soon as the financial reports have been submitted.',
		'Required before the first financial report can be submitted':
			'Required before the first financial report can be submitted',
		Skills4Retail: 'Skills4Retail',
		// The concept's own lane above the progress bar (#209)
		'Skills4Retail – can be worked on at any time': 'Skills4Retail – can be worked on at any time',
		'Skills4Retail submission': 'Submission',
		'Skills4Retail due by {{date}}': 'by {{date}}',
		'Skills4Retail due before the review': 'before the review',
		'Skills4Retail due before the first report': 'before the first report',
		'Skills4Retail submitted': 'done',
		Certificates: 'Certificates',
		'Your certificates are in your documents.': 'Your certificates are in your documents.',
		'The certificates are issued once the business report is uploaded and all invoices are paid.':
			'The certificates are issued once the business report is uploaded and all invoices are paid.',

		// Teacher dashboard: which supervised Junior Company is shown
		'Switch Junior Company': 'Switch Junior Company',
		'You supervise {{total}} Junior Companies': 'You supervise {{total}} Junior Companies',
		'Currently shown': 'Currently shown',
		'You are not supervising any Junior Company yet.': 'You are not supervising any Junior Company yet.',
		// Company employees: list, detail window, invitations
		'Show details': 'Show details',
		'Make CEO': 'Assign managing director (CEO)',
		'Managing director (CEO)': 'Managing director (CEO)',
		'The CEO function is transferred to {{name}}. The current CEO loses it.':
			'The CEO function is transferred to {{name}}. The current CEO loses it.',
		Invitation: 'Invitation',
		Validity: 'Validity',
		'Invitation deleted': 'Invitation deleted',
		'The invitation will be withdrawn.': 'The invitation will be withdrawn.',
		'The invitation to {{email}} will be withdrawn.': 'The invitation to {{email}} will be withdrawn.',
		'An invitation has been sent — the account does not exist yet.':
			'An invitation has been sent — the account does not exist yet.',
		'Invited by': 'Invited by',
		'Invited on': 'Invited on',
		'The person receives an email with a registration link. Until they have registered, the invitation is shown in the employee list.':
			'The person receives an email with a registration link. Until they have registered, the invitation is shown in the employee list.',
		// Lebensmittelhygiene und Allergeninformation (Anforderung #96)
		'Note on food hygiene and allergen information': 'Note on food hygiene and allergen information',
		'Statutory requirements apply to the production, processing, sale and labelling of food as well as products and services applied to the body. If the hygiene and allergen training is not covered in the curriculum, it must be completed before production begins. All information and the courses can be found at':
			'Statutory requirements apply to the production, processing, sale and labelling of food as well as products and services applied to the body. If the hygiene and allergen training is not covered in the curriculum, it must be completed before production begins. All information and the courses can be found at',
		'These requirements apply regardless of whether the sale is made for payment, within the school context or only occasionally. Please clarify with your teacher before production begins how these contents are covered in your Junior Company, and confirm this below.':
			'These requirements apply regardless of whether the sale is made for payment, within the school context or only occasionally. Please clarify with your teacher before production begins how these contents are covered in your Junior Company, and confirm this below.',
		'The information is a self-declaration of the Junior Company. Junior Achievement Austria only provides the platform for documentation, does not carry out any review and does not give legal advice. The school, the school authority and the supervising teacher are responsible for complying with the applicable regulations. This entry does not replace any officially required certificates or approvals.':
			'The information is a self-declaration of the Junior Company. Junior Achievement Austria only provides the platform for documentation, does not carry out any review and does not give legal advice. The school, the school authority and the supervising teacher are responsible for complying with the applicable regulations. This entry does not replace any officially required certificates or approvals.',
		'Show less': 'Show less',
		'The contents on food hygiene and allergen information are integrated into the curriculum.':
			'The contents on food hygiene and allergen information are integrated into the curriculum.',
		'Food hygiene and allergen training completed.': 'Food hygiene and allergen training completed.',
		'Contents are integrated into the curriculum.': 'Contents are integrated into the curriculum.',
		'Please select the employees who completed the training.':
			'Please select the employees who completed the training.',
		Participants: 'Participants',
		'Date of training': 'Date of training',
		'Confirmed by': 'Confirmed by',
		'No employees yet.': 'No employees yet.',
		Confirm: 'Confirm',
		'Confirm again': 'Confirm again',
		'Confirmation saved.': 'Confirmation saved.',
		'Please select one of the two statements.': 'Please select one of the two statements.',
		'Please save the branch first — the confirmation belongs to the saved branch.':
			'Please save the branch first — the confirmation belongs to the saved branch.',
		'A completed training cannot be withdrawn.': 'A completed training cannot be withdrawn.',
		'No confirmation has been submitted yet.': 'No confirmation has been submitted yet.',
		'The supervising teacher has objected to this confirmation.':
			'The supervising teacher has objected to this confirmation.',
		'Object to this confirmation': 'Object to this confirmation',
		Object: 'Object',
		'Objection saved.': 'Objection saved.',
		'Please state briefly why the confirmation is not correct.':
			'Please state briefly why the confirmation is not correct.',
		'Skills4Retail concept completed and assessed': 'Skills4Retail concept completed and assessed',
		'Your concept must be submitted and assessed by your teacher':
			'Your concept must be submitted and assessed by your teacher',
		'To the concept': 'To the concept',
		'Food hygiene and allergen information confirmed': 'Food hygiene and allergen information confirmed',
		'Confirm how food hygiene and allergen information is covered in your company':
			'Confirm how food hygiene and allergen information is covered in your company',
		'To the business activity': 'To the business activity',
		'Download your documents before the annual reset': 'Download your documents before the annual reset',
		'On {{val1}} all Junior Companies and student accounts will be deleted. Please download everything you want to keep beforehand — certificates, reports and documents.':
			'On {{val1}} all Junior Companies and student accounts will be deleted. Please download everything you want to keep beforehand — certificates, reports and documents.',
		'To the documents': 'To the documents',
		'Food hygiene: confirmation submitted': 'Food hygiene: confirmation submitted',
		'Course completed — congratulations!': 'Course completed — congratulations!',
		'You have passed every chapter of the Skills4Retail course.':
			'You have passed every chapter of the Skills4Retail course.',
		'{{val1}} of {{val2}} required completions are done.': '{{val1}} of {{val2}} required completions are done.',
		'Everyone in the Junior Company has finished.': 'Everyone in the Junior Company has finished.',
		'One person has not finished yet.': 'One person has not finished yet.',
		'{{val1}} people have not finished yet.': '{{val1}} people have not finished yet.',
		'Next, your teacher assesses the concept — only then can the company be activated.':
			'Next, your teacher assesses the concept — only then can the company be activated.',
		'Next, your teacher assesses the concept — only then can you submit the financial report.':
			'Next, your teacher assesses the concept — only then can you submit the financial report.',
		'The concept is currently not required for your Junior Company — you can still fetch your certificate.':
			'The concept is currently not required for your Junior Company — you can still fetch your certificate.',
		'Next, your teacher assesses the concept.': 'Next, your teacher assesses the concept.',
		'{{val1}} has completed the course': '{{val1}} has completed the course',
		'A student': 'A student',
		'In the Junior Company {{val1}}:': 'In the Junior Company {{val1}}:',
		'Concept awaiting your assessment': 'Concept awaiting your assessment',
		'The Junior Company {{val1}} has completed its concept on e-commerce and digital marketing. Please assess the fifteen fields with 0 to 10 points each.':
			'The Junior Company {{val1}} has completed its concept on e-commerce and digital marketing. Please assess the fifteen fields with 0 to 10 points each.',
		'{{val1}} has returned your concept for revision. You can edit it again.':
			'{{val1}} has returned your concept for revision. You can edit it again.',
		'Concept assessed': 'Concept assessed',
		'{{val1}} has assessed your concept: {{val2}} out of {{val3}} points.':
			'{{val1}} has assessed your concept: {{val2}} out of {{val3}} points.',
		'Concept assessment still pending': 'Concept assessment still pending',
		'The concept of the Junior Company {{val1}} has been waiting {{val2}} days for your assessment.':
			'The concept of the Junior Company {{val1}} has been waiting {{val2}} days for your assessment.',
		'to the concept': 'to the concept',
		'The Junior Company {{val1}} operates in a sensitive branch ({{val2}}) and has confirmed: {{val3}}':
			'The Junior Company {{val1}} operates in a sensitive branch ({{val2}}) and has confirmed: {{val3}}',
		'to the dashboard': 'to the dashboard',
		'Food hygiene: objection by your teacher': 'Food hygiene: objection by your teacher',
		'{{val1}} has objected to your confirmation on food hygiene and allergen information. Please clarify it together and confirm again.':
			'{{val1}} has objected to your confirmation on food hygiene and allergen information. Please clarify it together and confirm again.',
		'Food hygiene training still open': 'Food hygiene training still open',
		'For {{val1}} the food hygiene and allergen training has not been completed yet. It must be completed before production begins.':
			'For {{val1}} the food hygiene and allergen training has not been completed yet. It must be completed before production begins.',
		'Food hygiene confirmation submitted': 'Food hygiene confirmation submitted',
		'Concept submitted for assessment': 'Concept submitted for assessment',
		'Concept returned for revision': 'Concept returned for revision',
		'Concept fully assessed': 'Concept fully assessed',
		'Exempted from the concept quizzes': 'Exempted from the concept quizzes',
		'Quiz exemption revoked': 'Quiz exemption revoked',
		'Concept requirement waived by the administration': 'Concept requirement waived by the administration',
		'Objection to the food hygiene confirmation': 'Objection to the food hygiene confirmation',
		'Leave company': 'Leave company',
		'You will be removed from this Junior Company and logged out.':
			'You will be removed from this Junior Company and logged out.',
		'Leaving is not possible.': 'Leaving is not possible.',
		'An activated company needs at least two employees.': 'An activated company needs at least two employees.',
		'Are you sure?': 'Are you sure?',
		Proofs: 'Proofs',
		'Assigned to': 'Assigned to',
		'No document uploaded yet': 'No document uploaded yet',
		'Upload document': 'Upload document',
		'Replace document': 'Replace document',
		'Uploading…': 'Uploading…',
		'Document uploaded': 'Document uploaded',
		'The file is too large. Maximum 10 MB.': 'The file is too large. Maximum 10 MB.',
		'You can upload the required documents on behalf of this student. The document stays assigned to the student.':
			'You can upload the required documents on behalf of this student. The document stays assigned to the student.',
		'Uploading on behalf of students is not enabled for this company type.':
			'Uploading on behalf of students is not enabled for this company type.',
		'Einverständniserklärung der Erziehungsberechtigten — Upload durch die Lehrkraft':
			'Parental consent form — upload by the teacher',
		'Parental confirmation uploaded by the teacher': 'Parental confirmation uploaded by the teacher',
		'Course certificate uploaded by the teacher': 'Course certificate uploaded by the teacher',
		Reason: 'Reason',
		'Please give a reason.': 'Please give a reason.',
		'Object to this document?': 'Object to this document?',
		'The student is informed and can upload a replacement. The file stays and can still be viewed.':
			'The student is informed and can upload a replacement. The file stays and can still be viewed.',
		'e.g. signature is missing': 'e.g. signature is missing',
		'Delete this document?': 'Delete this document?',
		'The file is deleted for good. The student is informed and has to upload a new one.':
			'The file is deleted for good. The student is informed and has to upload a new one.',
		'e.g. wrong file uploaded': 'e.g. wrong file uploaded',
		'Document objected to': 'Document objected to',
		'Document deleted': 'Document deleted',
		'Document removed': 'Document removed',
		'The document': 'The document',
		'{{val1}} was removed by your teacher. Please upload the correct file again.':
			'{{val1}} was removed by your teacher. Please upload the correct file again.',
		'This company is activated. This document is a requirement for activation and can no longer be replaced, objected to or deleted.':
			'This company is activated. This document is a requirement for activation and can no longer be replaced, objected to or deleted.',
		'Object to document': 'Object',
		'Parental confirmation objected to by the teacher': 'Parental confirmation objected to by the teacher',
		'Course certificate objected to by the teacher': 'Course certificate objected to by the teacher',
		'Parental confirmation removed by the teacher': 'Parental confirmation removed by the teacher',
		'Previous month': 'Previous month',
		'Next month': 'Next month',
		Month: 'Month',
		Year: 'Year',
		Added: 'Added',
		'Last 24 hours': 'Last 24 hours',
		'Last 7 days': 'Last 7 days',
		'Last 30 days': 'Last 30 days',
		'All Junior Companies on record.': 'All Junior Companies on record.',
		'Created in the last 24 hours.': 'Created in the last 24 hours.',
		'Submitted for review — waiting to be activated by the administration.':
			'Submitted for review — waiting to be activated by the administration.',
		'Registered and not yet activated.': 'Registered and not yet activated.',
		'Activated Junior Companies.': 'Activated Junior Companies.',
		'All students on record.': 'All students on record.',
		'Parental confirmation uploaded and not yet checked.': 'Parental confirmation uploaded and not yet checked.',
		'Parental confirmation checked.': 'Parental confirmation checked.',
		'Neither uploaded nor checked yet.': 'Neither uploaded nor checked yet.',
		'All teachers on record.': 'All teachers on record.',
		'Not yet released — waiting to be confirmed by the administration.':
			'Not yet released — waiting to be confirmed by the administration.',
		'Released teachers.': 'Released teachers.',
		'All invoices except the cancelled ones.': 'All invoices except the cancelled ones.',
		'Issued in the last 24 hours.': 'Issued in the last 24 hours.',
		'Issued and not yet paid.': 'Issued and not yet paid.',
		'Paid invoices.': 'Paid invoices.',
		'Overdue invoices.': 'Overdue invoices.',
		'Invoices in credit.': 'Invoices in credit.',
		'Cancelled invoices.': 'Cancelled invoices.',
		'All submitted reports.': 'All submitted reports.',
		'Submitted in the last 24 hours.': 'Submitted in the last 24 hours.',
		'This figure is currently not collected.': 'This figure is currently not collected.',
		'Course certificate removed by the teacher': 'Course certificate removed by the teacher',
		'Skills4Retail handbook': 'Skills4Retail handbook',
		'Opens the handbook on the Skills4Retail course and the concept as a PDF in a new tab.':
			'Opens the handbook on the Skills4Retail course and the concept as a PDF in a new tab.',
		'The handbook is loading …': 'The handbook is loading …',
		// Anforderung #182: fehlende Dokumente, Vorlagen für Lehrkräfte
		'All documents have been uploaded.': 'All documents have been uploaded.',
		'One document is still missing.': 'One document is still missing.',
		'Several documents are still missing.': '{{count}} documents are still missing.',
		'You will find the templates to download and the upload field directly with each document below.':
			'You will find the templates to download and the upload field directly with each document below.',
		'Documents are still missing': 'Documents are still missing',
		'Templates for your students': 'Templates for your students',
		'Looking for the consent form template for your students?': 'Looking for the consent form template for your students? You will find it under',
		'in „My profile“.': 'in „My profile“.',
		'Every student needs the consent form signed by a parent or guardian. Download the template for each Junior Company here — your students also find it in their own profile under „Documents“.':
			'Every student needs the consent form signed by a parent or guardian. Download the template for each Junior Company here — your students also find it in their own profile under “Documents”.',
		'As soon as you supervise a Junior Company, you will find the consent form template for its students here.':
			'As soon as you supervise a Junior Company, you will find the consent form template for its students here.',
		'The Junior Companies could not be loaded.': 'The Junior Companies could not be loaded.',
		// Notice after downloading the participation certificate (JC/JCC, request #212)
		'Your journey continues': 'Your journey continues',
		SupporterInvitationText:
			'Your path in the entrepreneurship scene can continue. Register <signup>here</signup> as a supporter so you never miss new events, or support new Junior Companies with your expertise.'
	}
}

export default en
